(function () {
	'use strict';
	angular.module('horses.services', []);
})();
(function() {
    'use strict';

    angular.module('horses.services')

    .controller('ServiceDialog',
        function(servicesService, $scope, groupItem, $mdDialog, toastr, CONSTRAINTS, WORKING_DAY_TIME) {
            var self = this;
            self.isNew = !groupItem;

            self.data = {};
            self.data.timeslots = [];

            self.experience = CONSTRAINTS.experience;
            self.ageCategory = CONSTRAINTS.ageCategory;
            self.weight = CONSTRAINTS.weight;

            self.renderTime = function(from, to) {
                self.time = [];
                for (var i = from; i < to; i += 15) {
                    self.time.push(i);
                }
            };

            self.renderTime(WORKING_DAY_TIME.start, WORKING_DAY_TIME.end);

            if (groupItem) {
                self.edit = true;
                self.data.name = groupItem.name;
                self.data.description = groupItem.description;
                self.data.ridersAmount = groupItem.ridersAmount;
                self.data.extraHorse = groupItem.extraHorse;
                self.data.duration = groupItem.duration;
                self.data.price = groupItem.price;
                self.data.experience = angular.copy(groupItem.experience);
                self.data.ageCategory = angular.copy(groupItem.ageCategory);
                self.data.weight = angular.copy(groupItem.weight);
                self.selectedTime = convertTimeslots(groupItem.timeslots);
            } else {
                self.data.ridersAmount = 1;
                self.data.extraHorse = false;
                self.data.experience = angular.copy(self.experience);
                self.data.ageCategory = angular.copy(self.ageCategory);
                self.data.weight = angular.copy(self.weight);
                self.selectedTime = angular.copy(self.time);
            }

            function convertTimeslots(timeslots) {
                var selectedTime = [];
                timeslots.forEach(function(timeslot) {
                    selectedTime.push(timeslot.start);
                });
                self.selectedTime = angular.copy(selectedTime);
                return self.selectedTime;
            }

            self.toggle = function(item, list) {
                if (!self.isNew) return;
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
            };

            self.exists = function(item, list) {
                return list.indexOf(item) > -1;
            };

            self.save = function() {
                self.data.timeslots = [];
                self.disabled = true;
                angular.forEach(self.selectedTime, function(item) {
                    var item = {
                        start: item,
                        end: item + self.data.duration
                    }

                    self.data.timeslots.push(item);

                });

                if (self.edit) {
                    servicesService.update(groupItem._id, self.data).then(function() {
                        $mdDialog.hide();
                    }).catch(function(err) {
                        toastr.error(err, 'Error');
                        self.disabled = false;
                    });
                } else {
                    servicesService.add(self.data).then(function() {
                        $mdDialog.hide();
                    }).catch(function(err) {
                        toastr.error(err, 'Error');
                        self.disabled = false;
                    });
                }
            };

            self.cancel = function() {
                $mdDialog.cancel();
            };

        }
    );
})();
(function () {
  'use strict';

  angular.module('horses.orders', []);
})();
(function() {
    'use strict';

    angular.module('horses.orders')

    .controller('OrdersDialog',
        function($scope, groupItem, $window, $mdDialog, services, ordersService) {
            var self = this;

            self.order = groupItem;

            angular.forEach(self.order.tickets, function(item) {
                item.serviceData = getServiceById(item.service.id, services);
                item.date = $window.moment(item.date).format("DD/MM/YYYY");
            });

            console.info('O', self.order);

            self.cancelOrder = function() {
                ordersService.cancel(self.order._id).then(function() {
                    $mdDialog.hide();
                }).catch(function(err) {
                    toastr.error(err, 'Error');
                });
            };

            self.cancel = function() {
                $mdDialog.cancel();
            };

            function getServiceById(serviceId, services) {
                return services.find(function(service) {
                    return service._id === serviceId;
                });
            }

        }
    );
})();
(function () {
  angular.module('horses.booking', ['ngMaterial', 'ngMessages']);
})();

(function () {
    angular.module('horses.booking')

        .controller('InfoDialog',

            function ($mdDialog, $window, soldTimeslots, date, services, reservedTickets, guides, horses) {
                var self = this;

                self.date = $window.moment(date).format('DD MMMM YYYY, dddd');

                // console.info('soldTimeslots', soldTimeslots);
                // console.info('reservedTickets', reservedTickets);
                // console.info('services', services);

                self.timeslots = _.uniq(soldTimeslots);

                var reservedTickets = reservedTickets || [];

                reservedTickets = _.filter(reservedTickets, function (item) {
                    return item.order.status === 1 || item.order.status === 3 || item.order.status === 4; //?
                });

                console.info('reservedTickets: ', reservedTickets);

                services = associateTickets(services, reservedTickets);

                console.info('services: ', services);

                services = _.filter(services, function (item) {
                    return (item.ticketsSold && item.ticketsSold.length);
                });

                console.info('services after filter: ', services);
                self.services = services;
                self.guides = {};
                self.horses = {};

                angular.forEach(guides, function (guide) {
                    self.guides[guide._id] = { name: guide.firstName + ' ' + guide.lastName }
                });

                angular.forEach(horses, function (horse) {
                    self.horses[horse._id] = { name: horse.name }
                })

                function associateTickets(services, tickets) {
                    services.forEach(function (service) {
                        service.ticketsSold = [];
                        tickets.forEach(function (ticket) {
                            if (ticket.service.id === service._id) {
                                service.ticketsSold.push(ticket);
                            }
                        });
                    });
                    return services;
                }

                function calculateTotal(array) {
                    var tempCol = "";
                    for (var i = 0; i < array.length; i++) {
                        tempCol = array[i].serviceColOrigin;
                        var filterArr = _.filter(array, function (el) {
                            return array[i].serviceColOrigin === el.serviceColOrigin && array[i].timeColOrigin === el.timeColOrigin;
                        });
                        var total = 0;
                        angular.forEach(filterArr, function (item) {
                            if (item.amountCol) {
                                total = total + item.amountCol;
                            }
                        });
                        array[i].total = total;
                    }

                    return array;
                }

                function _calculateSlots(service) {
                    var slots = [];
                    var slotsMap = {};

                    angular.forEach(service.ticketsSold, function (ticket) {
                        if (!slotsMap[ticket.start]) {
                            slotsMap[ticket.start] = [];
                        }

                        slotsMap[ticket.start].push(ticket);
                    });

                    angular.forEach(slotsMap, function (slot, start) {
                        slots.push({
                            start: start,
                            customers: processCustomers(slot)
                        })
                    });

                    function processCustomers(slot) {
                        var customers = [];
                        var customersMap = {};

                        angular.forEach(slot, function (item) {
                            var key = item.order.customer.email + ':' + item.order.customer.name;
                            if (!customersMap[key]) {
                                customersMap[key] = [];
                            }

                            customersMap[key].push(item);
                        });

                        console.info('customersMap', customersMap);

                        angular.forEach(customersMap, function (items) {
                            if (items.length) {
                                var customer = {
                                    name: items[0].order.customer.name,
                                    email: items[0].order.customer.email,
                                    phone: items[0].order.customer.phone,
                                    postal: items[0].order.customer.postal,
                                    comment: items[0].order.customer.comment,
                                    riders: [],
                                    guides: [],
                                    horses: [],
                                };

                                angular.forEach(items, function (item) {
                                    angular.forEach(item.guides, function (guide) {
                                        customer.guides.push(self.guides[guide.id] ? self.guides[guide.id].name : '"Removed guide"');
                                    });

                                    angular.forEach(item.horses, function (horse) {
                                        customer.horses.push(self.horses[horse] ? self.horses[horse].name : '"Removed horse"');
                                    });

                                    angular.forEach(item.persons, function (p) {
                                        customer.riders.push(p)
                                    });
                                });

                                customer.guides = _.uniq(customer.guides);

                                customer.horses = _.uniq(customer.horses);

                                customers.push(customer);
                            }

                        });

                        return customers;
                    }

                    console.info('S', service.name, slots);

                    return slots;
                }

                function calculateReport() {
                    var result = [];

                    angular.forEach(self.services, function (service) {
                        service.ticketsSold.sort(function (a, b) {
                            return a.start - b.start;
                        });

                        var slots = _calculateSlots(service);

                        result.push({
                            id: service.id,
                            name: service.name,
                            slots: $window._.compact(slots)
                        });
                    });

                    result = calculateTotal(result);

                    console.info('report: ', result);

                    return result;
                }

                var data = calculateReport();

                console.info('data calculateReport: ', data);

                function prepareToRender(data) {
                    var result = [];

                    angular.forEach(data, function (service) {
                        console.info('service', service.name);
                        angular.forEach(service.slots, function (slot) {
                            console.info('\tslot', slot.start);
                            var total = 0;
                            angular.forEach(slot.customers, function (customer) {
                                console.info('\t\tcustomer', customer.name);
                                var amount = customer.riders.length;
                                total += amount;
                                angular.forEach(customer.riders, function (rider) {
                                    console.info('\t\t\trider', rider.name);
                                    result.push({
                                        service: { name: service.name },
                                        slot: slot.start,
                                        amount: amount,
                                        total: total,
                                        customer: {
                                            name: customer.name,
                                            email: customer.email,
                                            phone: customer.phone || '',
                                            postal: customer.postal || '',
                                            comment: customer.comment || '',
                                        },
                                        rider: rider,
                                        guides: customer.guides,
                                        horses: customer.horses
                                    });
                                });
                            });
                        });
                    });

                    return result;
                }

                self.data = prepareToRender(data);

                console.info('DATA', self.data);

                self.print = function () {
                    $window.printJS({
                        printable: 'printJS-content',
                        type: 'html'
                    });
                };

                self.cancel = function () {
                    $mdDialog.cancel();
                };

                self.formatListOfItems = function (array) {
                    return array.join(', ');
                }

            });

})();
(function () {
  'use strict';

  angular.module('horses.horses', []);
})();
(function () {
	'use strict';

	angular.module('horses.horses')

		.controller('HorsesDialog',
			function (horsesService, $scope, groupItem, $mdDialog, toastr, CONSTRAINTS) {
				var self = this;
				self.isNew = !groupItem;

				self.data = {};

                self.experience = CONSTRAINTS.experience;
                self.ageCategory = CONSTRAINTS.ageCategory;
                self.weight = CONSTRAINTS.weight;

				if (groupItem) {
					self.edit = true;
					self.data.name = groupItem.name;
                    self.data.experience = angular.copy(groupItem.experience);
                    self.data.ageCategory = angular.copy(groupItem.ageCategory);
                    self.data.weight = angular.copy(groupItem.weight);
				} else {
                    self.data.experience = angular.copy(self.experience);
                    self.data.ageCategory = angular.copy(self.ageCategory);
                    self.data.weight = angular.copy(self.weight);
                }

				self.toggle = function (item, list) {
					var idx = list.indexOf(item);
					if (idx > -1) {
						list.splice(idx, 1);
					}
					else {
						list.push(item);
					}
				};

				self.exists = function (item, list) {
					return list.indexOf(item) > -1;
				};

				self.save = function () {
					self.disabled = true;
					if (self.edit) {
						horsesService.update(groupItem._id, self.data).then(function () {
							$mdDialog.hide();
						}).catch(function (err) {
							toastr.error(err, 'Error');
							self.disabled = false;
						});
					} else {
						horsesService.add(self.data).then(function () {
							$mdDialog.hide();
						}).catch(function (err) {
							toastr.error(err, 'Error');
							self.disabled = false;
						});
					}

				};

				self.cancel = function () {
					$mdDialog.cancel();
				};

			}
		);
})();

(function () {
  'use strict';

  angular.module('horses.guides', []);
})();

(function () {
    'use strict';

    angular.module('horses.guides')

        .controller('GuidesDialog',
            function (guidesService, $scope, groupItem, $mdDialog, toastr, CONSTRAINTS, services) {
                var self = this;

                self.isNew = !groupItem;
                self.data = {};
                self.services = services;
                if (groupItem) {
                    self.data.firstName = groupItem.firstName;
                    self.data.lastName = groupItem.lastName;
                    self.data.email = groupItem.email;
                    self.data.address = groupItem.address;
                    self.data.phone = groupItem.phone;
                    angular.forEach(groupItem.services, function (i) {
                        angular.forEach(self.services, function (item) {
                            if (item._id === i._id) item.ticked = true;
                        });
                    });
                } else {
                    angular.forEach(self.services, function (item) {
                        item.ticked = true;
                    });
                }

                self.save = function () {
                    self.disabled = true;
                    if (!self.isNew) {
                        self.data.services = _.map(self.data.services, function (item) {
                            if (typeof item === 'object') {
                                return item._id
                            } else {
                                return item
                            }

                        });
                        guidesService.update(groupItem._id, self.data).then(function () {
                            $mdDialog.hide();
                        }).catch(function (err) {
                            toastr.error(err, 'Error');
                            self.disabled = false;
                        });
                    } else {
                        self.data.services = _.map(self.data.services, function (item) {
                            if (typeof item === 'object') {
                                return item._id
                            } else {
                                return item
                            }
                        });
                        guidesService.add(self.data).then(function () {
                            $mdDialog.hide();
                        }).catch(function (err) {
                            toastr.error(err.data.error.message, 'Error');
                            self.disabled = false;
                        });
                    }
                };

                self.cancel = function() {
                    $mdDialog.cancel();
                };

            }
        );
})();

(function() {
    angular.module('horses', [
        'ngAnimate',
        'ngMessages',
        'restangular',
        'ui.router',
        'ngMaterial',
        'toastr',
        'materialCalendar',
        'angular-jwt',
        'ngStorage',
        'horses.constants',
        'ui.mask',
        'angular-loading-bar',
        'facebook-pixel',
        'horses.shared',
        'horses.services',
        'horses.login',
        'horses.forgot-password',
        'horses.password-recovery',
        'horses.base',
        'horses.guides',
        'horses.orders',
        'horses.validate-ticket',
        'horses.horses',
        'horses.booking',
        'horses.availability',
        'horses.dashboard',
        'isteven-multi-select',
        'angular-uuid',
        'md-steppers'
    ])

    .constant('CONSTRAINTS', {
        experience: ["beginner", "novice", "intermediate", "experienced"],
        ageCategory: ["4-5", "6-10", "11-16", ">16"],
        weight: ["<11", "11-12", "13-15", "16-17"]
    })

    .constant('WORKING_DAY_TIME', {
        start: 480,
        end: 1200,
        step: 15
    })

    .constant('RIDERS_BY_ONE_GUIDE', {
        amount: 6
    })

    .constant('TICKET_STATUS', {
        reserved: 1,
        canceled: 2,
        charge: {
            pending: 3,
            succeeded: 4,
            failed: 5,
            refund: 6
        }
    })


    .config(function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
    })

    .config(function ($pixelProvider, CANTREF_FB_PIXEL_ID) {
        if (CANTREF_FB_PIXEL_ID) {
            $pixelProvider.id = CANTREF_FB_PIXEL_ID; // required, pixel id
            $pixelProvider.currency = 'GBP'; // optional, default is TWD!
            $pixelProvider.disablePushState = false; // optional, default is false
            $pixelProvider.delayPageView = true; // optional, default is false
            console.info('init fb pixel: ', CANTREF_FB_PIXEL_ID);
        }
    })

    .config(function($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function(date) {
            return date ? moment(date).format('DD/MM/YYYY') : ''
        }
    })

    .config(function($locationProvider) {
        $locationProvider
            .html5Mode({
                enabled: true
            });
    })

    .config(function($urlRouterProvider) {
        $urlRouterProvider.when('', '/');
        $urlRouterProvider.otherwise("/");
    })

    .config(function(toastrConfig) {
        angular.extend(toastrConfig, {
            timeOut: 3000
        });
    })

    .config(function(RestangularProvider, CANTREF_API_END_POINT) {
        RestangularProvider.setBaseUrl(CANTREF_API_END_POINT);

        RestangularProvider.addResponseInterceptor(function(data, operation, what, url, response) {
            // console.info('RESP INTERCEPTOR: ', data, operation, what, url, response);
            if (response.data.docs) {
                return response.data;
            } else {
                return response.data.data;
            }
        });

        RestangularProvider.setRestangularFields({
            id: "_id",
            route: "restangularRoute",
            selfLink: "self.href"
        });

    })

    .config(['$localStorageProvider',
        function($localStorageProvider) {
            $localStorageProvider.setKeyPrefix('horse');
        }
    ])

    .config(['uiMask.ConfigProvider', function(uiMaskConfigProvider) {
        uiMaskConfigProvider.allowInvalidValue = true;

        uiMaskConfigProvider.maskDefinitions({
            '9': /\d/,
            '1': /[0-1]/,
            '2': /[0-2]/,
            '3': /[0-3]/,
            '4': /[0-4]/,
            '5': /[0-5]/,
            '6': /[0-6]/,
            '7': /[0-7]/,
            '8': /[0-8]/,
            '0': /0/,
            'a': /[a-z]/,
            'A': /[a-zA-Z]/,
            '*': /[a-zA-Z0-9]/
        });
    }])

    .config(function Config($httpProvider, jwtInterceptorProvider) {
        // Please note we're annotating the function so that the $injector works when the file is minified
        jwtInterceptorProvider.tokenGetter = ['config', 'userService', function(config, userService) {
            // Skip authentication for any requests ending in .html
            if (config.url.substr(config.url.length - 5) == '.html') {
                return null;
            }

            return userService.getToken();
        }];

        $httpProvider.interceptors.push('jwtInterceptor');
    })

    .run(function($rootScope, $state, $stateParams, Restangular, userService, $mdDialog) {

        Restangular.setErrorInterceptor(function(response) {
            if (response.status === 401 || response.status === 403) {
                userService.logout();

                return false; // error handled
            }
            return true; // error not handled
        });

        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;

        $rootScope.safeApply = function(fn) {
            var phase = this.$root.$$phase;
            if (phase == '$apply' || phase == '$digest')
                this.$eval(fn);
            else
                this.$apply(fn);
        };

        $rootScope.$on('$stateChangeStart', function(event, toState) {
            $mdDialog.cancel();

            var authorizedRoles = _.get(toState, 'data.authorizedRoles');
            if (!userService.isLoggedIn()) {
                if (!userService.isRole(authorizedRoles)) {
                    event.preventDefault();
                    $state.go('login');
                }
            } else {
                if (!userService.isRole(authorizedRoles)) {
                    event.preventDefault();
                    var settings = userService.getSettings();
                    $state.go(settings.defaultState);
                    // $state.go('app.guides');
                } else {
                    if (authorizedRoles && !userService.isRole(authorizedRoles)) {
                        event.preventDefault();
                        $log.warn('Not authorized!, expected:', toState.data.authorizedRoles, ' got: ', userService.getUserInfo().role);
                    }
                }
            }

        });

        $rootScope.$on('$stateChangeSuccess', function() {
            $rootScope.$broadcast('spinnerStatus', false);
        });

    });

    angular.module('horses.shared', []);

})();
 'use strict';
angular.module('horses.shared')
  .directive('time', function () {
    return {
      restrict: 'E',
      templateUrl: 'app/components/time/time.html',
      scope: {
        time: '=?'
      },
      link: function (scope) {
        if (scope.time) {
              scope.h = Math.floor(scope.time / 60);
              scope.m = scope.time % 60;
              scope.h = scope.h < 10 ? '0' + scope.h : scope.h;
              scope.m = scope.m < 10 ? '0' + scope.m : scope.m;
          }

      }
    };
  });



(function () {
  'use strict';

  angular.module('horses.shared')

    .directive('loadingSpinner', function () {
      return {
        restrict: 'E',
        templateUrl: 'app/components/loadingSpinner/loadingSpinner.html',
        link: function (scope) {
          scope.$on('spinnerStatus', function (event, isActive) {
            scope.spinnerActive = isActive;
          });
        }
      };
    });

})();

(function () {
    'use strict';
    angular.module('horses.shared')
    .filter('timeFilter', function () {
        return function (item) {
           if (item) {
               var h = Math.floor(item / 60);
               var m = item % 60;
               h = h < 10 ? '0' + h : h;
               m = m < 10 ? '0' + m : m;
               return h +":"+ m;
           }
        };
    });
})();

(function () {
    'use strict';
    angular.module('horses.shared')
        .filter('statusFilter', function () {
            return function (status) {
                switch (status) {
                    case 1:
                        return "reserved";
                    case 2:
                        return "canceled";
                    case 3:
                        return "inprogress";
                    case 4:
                        return "paid";
                    case 5:
                        return "failed";
                    default:
                        return "unknown";
                }
            };
        });
})();
(function () {
    'use strict';
    angular.module('horses.shared')
    .filter('priceFilter', function () {
        return function (price) {
          return (price % 1 != 0) ? price.toFixed(2) : price;
        };
    });
})();

(function () {
    'use strict';
    angular.module('horses.shared')
    .filter('nameFilter', function () {
        return function (obj) {
           if (obj) return (obj.firstName || obj.lastName) ? obj.firstName + " " + obj.lastName : obj.email
        };
    });
})();

'use strict';

angular.module('horses.shared')

  .directive('compareTo',
    function () {
      return {
        require: "ngModel",
        scope: {
          otherModelValue: "=compareTo"
        },
        restrict: 'A',
        link: function(scope, element, attributes, ngModel) {

          ngModel.$validators.compareTo = function(modelValue) {
            return modelValue == scope.otherModelValue;
          };

          scope.$watch("otherModelValue", function() {
            ngModel.$validate();
          });
        }
      };
    }
  );

angular.module("materialCalendar", ["ngMaterial", "ngSanitize"]);

angular.module("materialCalendar").constant("materialCalendar.config", {
    version: "0.2.13",
    debug: document.domain.indexOf("localhost") > -1
});

angular.module("materialCalendar").config(["materialCalendar.config", "$logProvider", "$compileProvider", function(config, $logProvider, $compileProvider) {
    if (config.debug) {
        $logProvider.debugEnabled(false);
        $compileProvider.debugInfoEnabled(false);
    }
}]);

angular.module("materialCalendar").service("materialCalendar.Calendar", [function() {

    function Calendar(year, month, options) {

        var now = new Date();

        this.setWeekStartsOn = function(i) {
            var d = parseInt(i || 0, 10);
            if (!isNaN(d) && d >= 0 && d <= 6) {
                this.weekStartsOn = d;
            } else {
                this.weekStartsOn = 0;
            }
            return this.weekStartsOn;
        };

        this.options = angular.isObject(options) ? options : {};
        this.year = now.getFullYear();
        this.month = now.getMonth();
        this.weeks = [];
        this.weekStartsOn = this.setWeekStartsOn(this.options.weekStartsOn);

        this.next = function() {
            if (this.start.getMonth() < 11) {
                this.init(this.start.getFullYear(), this.start.getMonth() + 1);
                return;
            }
            this.init(this.start.getFullYear() + 1, 0);
        };

        this.prev = function() {
            if (this.month) {
                this.init(this.start.getFullYear(), this.start.getMonth() - 1);
                return;
            }
            this.init(this.start.getFullYear() - 1, 11);
        };

        // Month should be the javascript indexed month, 0 is January, etc.
        this.init = function(year, month) {
            var now = new Date();
            this.year = angular.isDefined(year) ? year : now.getFullYear();
            this.month = angular.isDefined(month) ? month : now.getMonth();

            var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var monthLength = daysInMonth[this.month];

            // Figure out if is a leap year.
            if (this.month === 1) {
                if ((this.year % 4 === 0 && this.year % 100 !== 0) || this.year % 400 === 0) {
                    monthLength = 29;
                }
            }

            // First day of calendar month.
            this.start = new Date(this.year, this.month, 1);
            var date = angular.copy(this.start);
            while (date.getDay() !== this.weekStartsOn) {
                date.setDate(date.getDate() - 1);
                monthLength++;
            }

            // Last day of calendar month.
            while (monthLength % 7 !== 0) {
                monthLength++;
            }

            this.weeks = [];
            for (var i = 0; i < monthLength; ++i) {

                // Let's start a new week.
                if (i % 7 === 0) {
                    this.weeks.push([]);
                }

                // Add copy of the date. If not a copy,
                // it will get updated shortly.
                this.weeks[this.weeks.length - 1].push(angular.copy(date));

                // Increment it.
                date.setDate(date.getDate() + 1);

            }

        };

        this.init(year, month);

    }

    return Calendar;

}]);

angular.module("materialCalendar").service("MaterialCalendarData", [function() {
    function CalendarData() {

        this.data = {};

        this.getDayKey = function(date) {
            return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join("-");
        };

        this.setDayContent = function(date, content) {
            this.data[this.getDayKey(date)] = content || this.data[this.getDayKey(date)] || "";
        };
    }

    return new CalendarData();
}]);

angular.module("materialCalendar").directive("calendarMd", ["$compile", "$parse", "$http", "$q", "materialCalendar.Calendar", "MaterialCalendarData", "$templateCache", function($compile, $parse, $http, $q, Calendar, CalendarData, $templateCache) {

    var defaultTemplate = "<md-content layout='column' layout-fill md-swipe-left='next()' md-swipe-right='prev()'><md-toolbar><div class='md-toolbar-tools' layout='row'><md-button class='md-icon-button' ng-click='prev()' aria-label='Previous month'><md-tooltip ng-if='::tooltips()'>Previous month</md-tooltip>&laquo;</md-button><div flex></div><h2 class='calendar-md-title'><span>{{ calendar.start | date:titleFormat:timezone }}</span></h2><div flex></div><md-button class='md-icon-button' ng-click='next()' aria-label='Next month'><md-tooltip ng-if='::tooltips()'>Next month</md-tooltip>&raquo;</md-button></div></md-toolbar><!-- agenda view --><md-content ng-if='weekLayout === columnWeekLayout' class='agenda'><div ng-repeat='week in calendar.weeks track by $index'><div ng-if='sameMonth(day)' ng-class='{&quot;disabled&quot; : isDisabled(day), active: active === day }' ng-click='handleDayClick(day)' ng-repeat='day in week' layout><md-tooltip ng-if='::tooltips()'>{{ day | date:dayTooltipFormat:timezone }}</md-tooltip><div>{{ day | date:dayFormat:timezone }}</div><div flex ng-bind-html='dataService.data[dayKey(day)]'></div></div></div></md-content><!-- calendar view --><md-content ng-if='weekLayout !== columnWeekLayout' flex layout='column' class='calendar'><div layout='row' class='subheader'><div layout-padding class='subheader-day' flex ng-repeat='day in calendar.weeks[0]'><md-tooltip ng-if='::tooltips()'>{{ day | date:dayLabelTooltipFormat }}</md-tooltip>{{ day | date:dayLabelFormat }}</div></div><div ng-if='week.length' ng-repeat='week in calendar.weeks track by $index' flex layout='row'><div tabindex='{{ sameMonth(day) ? (day | date:dayFormat:timezone) : 0 }}' ng-repeat='day in week track by $index' ng-click='handleDayClick(day)' flex layout layout-padding ng-class='{&quot;disabled&quot; : isDisabled(day), &quot;active&quot;: isActive(day), &quot;md-whiteframe-12dp&quot;: hover || focus }' ng-focus='focus = true;' ng-blur='focus = false;' ng-mouseleave='hover = false' ng-mouseenter='hover = true'><md-tooltip ng-if='::tooltips()'>{{ day | date:dayTooltipFormat }}</md-tooltip><div>{{ day | date:dayFormat }}</div></div></div></md-content></md-content>";

    var injectCss = function() {
        var styleId = "calendarMdCss";
        if (!document.getElementById(styleId)) {
            var head = document.getElementsByTagName("head")[0];
            var css = document.createElement("style");
            css.type = "text/css";
            css.id = styleId;
            css.innerHTML = "calendar-md md-content>md-content.agenda>*>* :not(:first-child),calendar-md md-content>md-content.calendar>:not(:first-child)>* :last-child{overflow:hidden;text-overflow:ellipsis}calendar-md{display:block;max-height:100%}calendar-md .md-toolbar-tools h2{overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}calendar-md md-content>md-content{border:1px solid rgba(0,0,0,.12)}calendar-md md-content>md-content.agenda>*>*{border-bottom:1px solid rgba(0,0,0,.12)}calendar-md md-content>md-content.agenda>*>.disabled{color:rgba(0,0,0,.3);pointer-events:none;cursor:auto}calendar-md md-content>md-content.agenda>*>* :first-child{padding:12px;width:200px;text-align:right;color:rgba(0,0,0,.75);font-weight:100;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}calendar-md md-content>md-content>*>*{min-width:48px}calendar-md md-content>md-content.calendar>:first-child{background:rgba(0,0,0,.02);border-bottom:1px solid rgba(0,0,0,.12);margin-right:0;min-height:36px}calendar-md md-content>md-content.calendar>:not(:first-child)>*{border-bottom:1px solid rgba(0,0,0,.12);border-right:1px solid rgba(0,0,0,.12);cursor:pointer}calendar-md md-content>md-content.calendar>:not(:first-child)>:hover{background:rgba(0,0,0,.04)}calendar-md md-content>md-content.calendar>:not(:first-child)>.disabled{color:rgba(0,0,0,.3);pointer-events:none;cursor:auto}calendar-md md-content>md-content.calendar>:not(:first-child)>.active{box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);background:rgba(0,0,0,.02)}calendar-md md-content>md-content.calendar>:not(:first-child)>* :first-child{padding:0}";
            head.insertBefore(css, head.firstChild);
        }
    };

    return {
        restrict: "E",
        scope: {
            ngModel: "=?",
            template: "&",
            templateUrl: "=?",
            onDayClick: "=?",
            reloadEvents: "=?",
            onPrevMonth: "=?",
            onNextMonth: "=?",
            onSelectMonth: "=?",
            onSelectYear: "=?",
            calendarDirection: "=?",
            events: "=",
            dayContent: "&?",
            timezone: "=?",
            titleFormat: "=?",
            dayFormat: "=?",
            dayLabelFormat: "=?",
            dayLabelTooltipFormat: "=?",
            dayTooltipFormat: "=?",
            weekStartsOn: "=?",
            tooltips: "&?",
            clearDataCacheOnLoad: "=?",
            withoutContent: "=?",
            disableFutureSelection: "=?"
        },
        link: function($scope, $element, $attrs) {

            // Add the CSS here.
            injectCss();

            var date = new Date();
            var month = parseInt($attrs.startMonth || date.getMonth());
            var year = parseInt($attrs.startYear || date.getFullYear());


            $scope.year = year;
            $scope.years = [];
            for (var i = (year - 10); i <= (year + 10); i++) {
                $scope.years.push(i);
            }

            // $scope.month = {
            // 	key: month + 1
            // };
            $scope.months = [
                { name: 'January', key: '0' },
                { name: 'February', key: '1' },
                { name: 'March', key: '2' },
                { name: 'April', key: '3' },
                { name: 'May', key: '4' },
                { name: 'June', key: '5' },
                { name: 'July', key: '6' },
                { name: 'August', key: '7' },
                { name: 'September', key: '8' },
                { name: 'October', key: '9' },
                { name: 'November', key: '10' },
                { name: 'December', key: '11' }
            ];

            $scope.columnWeekLayout = "column";
            $scope.weekLayout = "row";
            $scope.timezone = $scope.timezone || null;
            $scope.noCache = $attrs.clearDataCacheOnLoad || false;

            // Parse the parent model to determine if it's an array.
            // If it is an array, than we'll automatically be able to select
            // more than one date.
            if ($attrs.ngModel) {
                $scope.active = $scope.$parent.$eval($attrs.ngModel);
                if ($attrs.ngModel) {
                    $scope.$watch("$parent." + $attrs.ngModel, function(val) {
                        $scope.active = val;
                    });
                }
            } else {
                $scope.active = null;
            }

            // Set the defaults here.
            $scope.titleFormat = $scope.titleFormat || "MMMM yyyy";
            $scope.dayLabelFormat = $scope.dayLabelFormat || "EEE";
            $scope.dayLabelTooltipFormat = $scope.dayLabelTooltipFormat || "EEEE";
            $scope.dayFormat = $scope.dayFormat || "d";
            $scope.dayTooltipFormat = $scope.dayTooltipFormat || "fullDate";
            $scope.disableFutureSelection = $scope.disableFutureSelection || false;

            $scope.sameMonth = function(date) {
                var d = angular.copy(date);
                return d.getFullYear() === $scope.calendar.year &&
                    d.getMonth() === $scope.calendar.month;
            };

            $scope.isDisabled = function(date) {
                if ($scope.disableFutureSelection && date > new Date()) {
                    return true;
                }
                return !$scope.sameMonth(date);
            };

            $scope.calendarDirection = $scope.calendarDirection || "horizontal";

            if ($scope.events !== undefined) {
                $scope.$watch("events", function(events) {
                  //  console.info('events were changed: ', events);

                    angular.forEach($scope.calendar.weeks, function(week) {
                        angular.forEach(week, function(day) {
                            $scope.dataService.setDayContent(day, "<p></p>");
                        });
                    });

                    angular.forEach(events, function(event) {
                        $scope.dataService.setDayContent(event.date, event.html);
                    });

                });
            }

            $scope.$watch("calendarDirection", function(val) {
                $scope.weekLayout = val === "horizontal" ? "row" : "column";
            });

            $scope.$watch("weekLayout", function() {
                year = $scope.calendar.year;
                month = $scope.calendar.month;
                bootstrap();
            });

            var handleCb = function(cb, data) {
                (cb || angular.noop)(data);
            };

            var dateFind = function(arr, date) {
                var index = -1;
                angular.forEach(arr, function(d, k) {
                    if (index < 0) {
                        if (angular.equals(date, d)) {
                            index = k;
                        }
                    }
                });
                return index;
            };

            $scope.isActive = function(date) {
                var match;
                var active = angular.copy($scope.active);
                if (!angular.isArray(active)) {
                    match = angular.equals(date, active);
                } else {
                    match = dateFind(active, date) > -1;
                }
                return match;
            };

            $scope.setDayContent = function(date, content) {
                $scope.dataService.setDayContent(date, content);
            };

            $scope.prev = function() {
                $scope.calendar.prev();
                var data = {
                    year: $scope.calendar.year,
                    month: $scope.calendar.month + 1
                };

                if (!$scope.withoutContent) {
                    CalendarData.data = {};
                }
                setData();
                handleCb($scope.onPrevMonth, data);
            };

            $scope.next = function() {
                $scope.calendar.next();
                var data = {
                    year: $scope.calendar.year,
                    month: $scope.calendar.month + 1
                };

                if (!$scope.withoutContent) {
                    CalendarData.data = {};
                }

                setData();
                handleCb($scope.onNextMonth, data);
            };

            $scope.selectMonth = function() {
                init();

                var data = {
                    year: $scope.calendar.year,
                    month: $scope.calendar.month + 1
                };
                CalendarData.data = {};
                setData();
                handleCb($scope.onSelectMonth, data);
            };

            $scope.selectYear = function() {
                init();

                var data = {
                    year: $scope.calendar.year,
                    month: $scope.calendar.month + 1
                };
                CalendarData.data = {};
                setData();
                handleCb($scope.onSelectYear, data);
            };

            $scope.handleDayClick = function(date) {

                if ($scope.disableFutureSelection && date > new Date()) {
                    return;
                }

                var active = angular.copy($scope.active);
                if (angular.isArray(active)) {
                    var idx = dateFind(active, date);
                    if (idx > -1) {
                        active.splice(idx, 1);
                    } else {
                        active.push(date);
                    }
                } else {
                    if (angular.equals(active, date)) {
                        active = null;
                    } else {
                        active = date;
                    }
                }

                $scope.active = active;
                if ($attrs.ngModel) {
                    $parse($attrs.ngModel).assign($scope.$parent, angular.copy($scope.active));
                }

                handleCb($scope.onDayClick, angular.copy(date));

            };

            // Small helper function to set the contents of the template.
            var setTemplate = function(contents) {
                $element.html(contents);
                $compile($element.contents())($scope);
            };


            var init = function() {
                var year;
                var month;

                if ($scope.calendar) {
                    year = $scope.calendar.year;
                    month = $scope.calendar.month;
                } else {
                    year = date.getFullYear();
                    month = date.getMonth();
                }

                $scope.calendar = new Calendar(parseInt(year), parseInt(month), {
                    weekStartsOn: $scope.weekStartsOn || 0
                });

                var deferred = $q.defer();
                // Allows fetching of dynamic templates via $http.
                if ($scope.templateUrl) {
                    $http
                        .get($scope.templateUrl, { cache: $templateCache })
                        .then(function(response) { return deferred.resolve(response.data) })
                        .catch(function(response) { return deferred.reject(response) });
                } else {
                    $http
                        .get('app/components/calendar/angular-material-calendar.html', { cache: $templateCache })
                        .then(function(response) { return deferred.resolve(response.data) })
                        .catch(function(response) { return deferred.reject(response) });
                    // deferred.resolve($scope.template() || defaultTemplate);
                }

                return deferred.promise;

            };

            $scope.dataService = CalendarData;

            // Set the html contents of each date.
            var getDayKey = function(date) {
                return $scope.dataService.getDayKey(date);
            };
            $scope.dayKey = getDayKey;

            // var getDayContent = function (date) {
            // 	console.info('getDayContent', date);
            // 	// var html = $scope.getDayContent(date);
            // 	//
            // 	// $scope.dataService.setDayContent(date, html);
            //
            // 	// Initialize the data in the data array.
            // 	if ($scope.noCache) {
            // 		$scope.dataService.setDayContent(date, "");
            // 	} else {
            // 		$scope.dataService.setDayContent(date, ($scope.dataService.data[getDayKey(date)] || ""));
            // 	}
            //
            // 	var cb = ($scope.dayContent || angular.noop)();
            // 	var result = (cb || angular.noop)(date);
            //
            // 	// Check for async function. This should support $http.get() and also regular $q.defer() functions.
            // 	if (angular.isObject(result) && "function" === typeof result.success) {
            // 		result.success(function (html) {
            // 			$scope.dataService.setDayContent(date, html);
            // 		});
            // 	} else if (angular.isObject(result) && "function" === typeof result.then) {
            // 		result.then(function (html) {
            // 			$scope.dataService.setDayContent(date, html);
            // 		});
            // 	} else {
            // 		$scope.dataService.setDayContent(date, result);
            // 	}
            //
            // };

            var setData = function() {
                var days = [];
                angular.forEach($scope.calendar.weeks, function(week) {
                    angular.forEach(week, function(day) {
                        if (day) {
                            days.push(day);
                        }
                    });
                });

                if (days.length) {
                    $scope.reloadEvents(days);
                }

                // angular.forEach($scope.calendar.weeks, function (week) {
                // 	angular.forEach(week, getDayContent);
                // });
            };

            // window.data = $scope.data;

            var bootstrap = function() {
                init().then(function(contents) {
                    setTemplate(contents);
                    setData();
                });
            };

            $scope.$watch("weekStartsOn", init);
            bootstrap();

            // These are for tests, don't remove them..
            $scope._$$init = init;
            $scope._$$setTemplate = setTemplate;
            $scope._$$bootstrap = bootstrap;

        }
    };

}]);
(function() {
    angular.module('horses.booking')

    .controller('PaymentDialog',

        function(
            $scope, $mdDialog, date, data, totalPrice, ticketsService, $pixel,
            ordersService, TICKET_STATUS, CANTREF_STRIPE_PUBLIC_KEY, $timeout, toastr) {
            var self = this;

            self.data = data;
            self.totalPrice = totalPrice;

            self.cancel = function() {
                if (self.orderId) {
                    ordersService.cancel(self.orderId).then(function() {
                        $mdDialog.cancel();
                        toastr.info('Your tickets unreserved!', 'Information');
                    }).catch(function(err) {
                        toastr.error(err.message, 'Error');
                    })
                } else {
                    $mdDialog.cancel();
                }
            };

            self.payment = "card";

            self.selectedStep = 0;
            self.stepProgress = 1;
            self.maxStep = 2;
            self.showBusyText = false;
            self.stepData = [
                { step: 1, completed: false, optional: false, data: {} },
                { step: 2, completed: false, optional: false, data: {} }
            ];
            self.enableNextStep = function nextStep() {
                if (self.selectedStep >= self.maxStep) {
                    return;
                }
                if (self.selectedStep === self.stepProgress - 1) {
                    self.stepProgress = self.stepProgress + 1;
                }
                self.selectedStep = self.selectedStep + 1;
            };
            self.submitCurrentStep = function submitCurrentStep(stepData) {

                self.showBusyText = true;
                if (!stepData.completed) {
                    var data = {};
                    data.customer = {
                        name: self.personalDetails.name,
                        phone: self.personalDetails.phone,
                        email: self.personalDetails.email,
                        postal: self.personalDetails.postal,
                        comment: self.personalDetails.comment
                    };
                    data.totalPrice = self.totalPrice;
                    data.tickets = self.data;
                    ordersService.reserve(data, date).then(function(resp) {
                        if(resp.status === 'unavalible'){
                            toastr.error(resp.message, 'Error');
                            $mdDialog.hide(resp);
                        }else{
                            self.orderId = resp._id;
                            self.showBusyText = false;
                            stepData.completed = true;
                            toastr.info('Your tickets reserved!', 'Information');
                            self.enableNextStep();
                        }
                    }).catch(function(err) {
                        console.log(err);
                        toastr.error(err.message, 'Error');
                    });

                } else {
                    self.showBusyText = false;
                    self.enableNextStep();
                }
            };

            var stripe = Stripe(CANTREF_STRIPE_PUBLIC_KEY);
            var elements = stripe.elements();

            var card = elements.create('card', {
                iconStyle: 'solid',
                style: {
                    base: {
                        iconColor: '#8898AA',
                        color: 'rgba(0,0,0,0.87)',
                        lineHeight: '36px',
                        fontWeight: 300,
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSize: '19px',

                        '::placeholder': {
                            color: '#8898AA'
                        }
                    },
                    invalid: {
                        iconColor: '#e85746',
                        color: '#e85746'
                    }
                },
                classes: {
                    focus: 'is-focused',
                    empty: 'is-empty'
                }
            });

            $timeout(function() {
                card.mount('#card-element');

                var inputs = document.querySelectorAll('div.field input');
                Array.prototype.forEach.call(inputs, function(input) {
                    input.addEventListener('focus', function() {
                        input.classList.add('is-focused');
                    });
                    input.addEventListener('blur', function() {
                        input.classList.remove('is-focused');
                    });
                    input.addEventListener('keyup', function() {
                        if (input.value.length === 0) {
                            input.classList.add('is-empty');
                        } else {
                            input.classList.remove('is-empty');
                        }
                    });
                });
            });

            self.charge = function() {
                if (self.payment === "cash") {
                    var data = {
                        type: "cash"
                    };
                    ordersService.pay(self.orderId, data).then(function() {
                        toastr.success('Your payment accepted!', 'Success');

                        $pixel.purchase(self.totalPrice);

                        $mdDialog.hide();
                    }).catch(function(err) {
                        toastr.error(err.message, 'Error');
                    });
                } else {
                    stripe.createToken(card).then(function (resp) {
                        var data = {
                            token: resp.token.id,
                            type: "card"
                        };

                        return ordersService.pay(self.orderId, data);
                    }).then(function (result) {
                        if (result.requires_action) {
                            self.paymentInProcess = true;

                            return stripeRequireAdditionalActions(result);
                        }

                        toastr.success('Your payment accepted!', 'Success');

                        $pixel.purchase(self.totalPrice);

                        $mdDialog.hide();
                    }).catch(function (err) {
                        toastr.error(err.message, 'Error');
                        self.paymentInProcess = false;
                    });
                }

            }

            function stripeRequireAdditionalActions (result) {
                stripe.handleCardAction(result.payment_intent_client_secret).then(function (result) {
                    if (result.error) {
                        var errorMessage = result.error.message || 'Can not pay'

                        if (result.error.message) {
                            errorMessage = result.error.message;
                        }

                        toastr.error(errorMessage, 'Error');
                        self.paymentInProcess = false;
                    } else {
                        ordersService.pay(self.orderId, {
                            type: "card",
                            payment_intent_id: result.paymentIntent.id,
                        }).then(function () {
                            toastr.success('Your payment accepted!', 'Success');

                            $pixel.purchase(self.totalPrice);

                            $mdDialog.hide();
                        }).catch(function (res) {
                            toastr.error(res.error.message, 'Error');
                            self.paymentInProcess = false;
                        });
                    }
                });
            }

        });

})();
(function () {
    angular.module('horses.booking')

        .controller('BookingDialog',

            function ($mdDialog, ticket, date, allowedPersons, serviceColor, services, RIDERS_BY_ONE_GUIDE, horses) {
                var self = this;
                self.ticket = angular.copy(ticket);
                self.date = filterDate(date);
                self.serviceColor = serviceColor;
                self.service = getServiceById(ticket.service, services);
                self.personsList = angular.copy(allowedPersons) || [];
                self.ridersByGuide = RIDERS_BY_ONE_GUIDE;
                self.countRiders = 0;

                angular.forEach(self.ticket.horses, function (horse) {
                    var index = _.findIndex(horses, function (i) {
                        return i._id === horse.id
                    });
                    horse.data = horses[index];
                });

                self.ticket.horses = _.filter(self.ticket.horses, function (horse) {
                    return horse.reservedBy === null;
                });

                self.addPersonToList = function (personsList) {
                    personsList.push({
                        name: "",
                        ageCategory: "",
                        weight: "",
                        experience: ""
                    });
                };

                if (self.personsList.length <= self.service.ridersAmount) {
                    var diff = self.service.ridersAmount - self.personsList.length;
                    for (var i = 0; i < diff; i++) {
                        self.addPersonToList(self.personsList);
                    }
                }

                self.confirmPersonsDisable = function (persons) {
                    var listNext = persons;
                    var guideTotal = (listNext - listNext % self.ridersByGuide.amount) / self.ridersByGuide.amount + (listNext % self.ridersByGuide.amount > 0 ? 1 : 0);
                    var horsesTotal = self.service.extraHorse ? listNext + guideTotal : listNext;
                    return countFreeGuides(self.ticket.guides) < listNext || countFreeHorses(self.ticket.horses) < horsesTotal || persons >= self.service.limit;
                };

                self.confirm = function (ticket, service, persons) {
                    ticket.persons = _.filter(persons, ['unsuitable', false]);
                    ticket.result = result;
                    ticket.price = result.length * ticket.price;
                    var ticketToAdd = {
                        ticket: ticket,
                        service: service
                    };
                    $mdDialog.hide(ticketToAdd);
                };

                self.cancel = function () {
                    $mdDialog.cancel();
                };

                self.removePerson = function (index) {
                    self.personsList.splice(index, 1);
                    self.choseHorses(self.personsList);
                };

                function getServiceById(serviceId, services) {
                    return services.find(function (service) {
                        service.limit = serviceId.limit;
                        return service._id === serviceId.id;
                    });
                }

                var result = [];
                var rider = 0;

                function matrix(personsList, horses) {
                    var matrix = [];
                    angular.forEach(personsList, function (person) {
                        if (person.ageCategory && person.weight && person.experience) {
                            var horsesOfRider = [];
                            angular.forEach(horses, function (horse) {
                                var ifAge = horse.data.ageCategory.indexOf(person.ageCategory) !== -1;
                                var ifWei = horse.data.weight.indexOf(person.weight) !== -1;
                                var ifExp = horse.data.experience.indexOf(person.experience) !== -1;
                                if (ifExp && ifWei && ifAge) {
                                    var obj = {
                                        id: horse.id,
                                        index: 0
                                    };
                                    horsesOfRider.push(obj);
                                }
                            });

                            var obj = {
                                rider: person,
                                horses: horsesOfRider,
                                index: rider++
                            };
                            matrix.push(obj);
                        }
                    });
                    return matrix;
                }

                function coefficient(matrix) {

                    angular.forEach(matrix, function (item) {
                        angular.forEach(item.horses, function (horse) {
                            horse.index = 0;
                        })
                    });

                    var arrOfHorses = [];

                    angular.forEach(matrix, function (item) {
                        angular.forEach(item.horses, function (horse) {
                            arrOfHorses.push(horse);
                        })
                    });

                    angular.forEach(arrOfHorses, function (horse) {
                        horse.index = countInArray(arrOfHorses, horse)
                    });

                    return matrix;

                }

                function findMin(matrix) {
                    var arrOfHorses = [];
                    angular.forEach(matrix, function (item) {
                        angular.forEach(item.horses, function (horse) {
                            arrOfHorses.push(horse);
                        });
                    });
                    return _.min(_.map(arrOfHorses, "index"));
                }

                function allocate(matrix, min) {

                    var arrOfHorses = [];
                    angular.forEach(matrix, function (item) {
                        item.unsuitable = false;
                        self.personsList[item.index].unsuitable = false;
                        if (!item.horses.length) {
                            item.unsuitable = true;
                            self.personsList[item.index].unsuitable = true;
                        }
                        angular.forEach(item.horses, function (horse) {
                            arrOfHorses.push(horse);
                        });
                    });
                    if (arrOfHorses.length) {
                        var horse = _.find(arrOfHorses, function (horse) {
                            return horse.index === min;
                        });

                        var arrOfRiders = [];

                        angular.forEach(matrix, function (item) {
                            angular.forEach(item.horses, function (h) {
                                if (h.id === horse.id) {
                                    arrOfRiders.push(item);
                                }
                            })
                        });

                        var minOfHorses = _.min(_.map(arrOfRiders, 'horses.length'));

                        var rider = _.find(arrOfRiders, function (rider) {
                            return rider.horses.length === minOfHorses;
                        });

                        var obj = {
                            rider: rider.rider,
                            horse: horse.id
                        };

                        result.push(obj);

                        shift(matrix, obj);

                        return obj;
                    }

                }

                function shift(matrix, rider) {
                    if (matrix.length) {
                        var index = _.findIndex(matrix, function (item) {
                            return item.rider.ageCategory === rider.rider.ageCategory && item.rider.name === rider.rider.name && item.rider.weight === rider.rider.weight && item.rider.experience === rider.rider.experience
                        });

                        matrix.splice(index, 1);

                        angular.forEach(matrix, function (item) {
                            var index = _.findIndex(item.horses, function (horse) {
                                return horse.id ===  rider.horse;
                            });
                            if(index !== -1) {
                                item.horses.splice(index, 1);
                            }
                        });
                        if (matrix.length) {
                            var m2 = coefficient(matrix);

                            var min = findMin(m2);

                            allocate(m2, min);
                        }

                    }
                }

                self.choseHorses = function (personsList) {

                    if (personsList[0].ageCategory && personsList[0].weight && personsList[0].experience) {
                        result = [];

                        rider = 0;

                        var m1 = matrix(personsList, self.ticket.horses);

                        var m2 = coefficient(m1);

                        var min = findMin(m2);

                        allocate(m2, min);

                        self.countRiders = result.length;

                    }

                };

                self.change = function (person) {
                    if (person.ageCategory && person.weight && person.experience) {
                        self.choseHorses(self.personsList);
                    }
                };

                self.choseHorses(self.personsList);

                function countInArray(array, what) {
                    var count = 0;
                    for (var i = 0; i < array.length; i++) {
                        if (array[i].id === what.id) {
                            count++;
                        }
                    }
                    return count;
                }

                function countFreeGuides(guides) {
                    var countFreeGuides = 0;
                    angular.forEach(guides, function (guide) {
                        countFreeGuides += guide.maxRiders - guide.reservedBy.length;
                    });
                    return countFreeGuides;
                }
                function countFreeHorses(horses) {
                    var arr = _.filter(horses, function (horse) {
                            return horse.reservedBy === null;
                        })
                    return arr.length;
                }

                function filterDate(date) {
                    var monthNames = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                    ];
                    return monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
                }

            });

})();

'use strict';

angular.module('horses.base', []);


(function () {
  'use strict';

  angular.module('horses.base')

    .controller('ProfileDialog',
      function ($mdDialog, user, userService, toastr) {
        var self = this;

        self.data = {};

        self.data.firstName = user.firstName;
        self.data.lastName = user.lastName;
        self.data.email = user.email;

        self.save = function () {

          userService.update(self.data).then(function () {
            $mdDialog.hide();
          }).catch(function (err) {
            toastr.error(err, 'Error');
          });
        };

        self.cancel = function() {
          $mdDialog.cancel();
        };

      }
    );
})();

(function () {

  angular.module('horses.availability', []);
})();


(function () {
  'use strict';

  angular.module('horses.availability')

    .controller('SetPriority',
      function ($filter, $timeout, services, guides, $mdDialog, toastr) {
        var self = this;
        var guidesCount = guides.length;
        var priorityValues = [{
          value: 0,
          displayValue: 'n/a'
        }];
        var shouldBeSetPriorities = services.length * guides.length;

        for (var i = 1; i <= guidesCount; i++){
          priorityValues.push({
            isSelected: false,
            value: i,
            displayValue: i
          })
        }

        self.services = _.cloneDeep(services);
        self.guides = _.cloneDeep(guides);
       
        angular.forEach(self.services, function(service) {
          service.guidesPriority = service.guidesPriority || [];
          if(service.guidesPriority.length === 0){
            service.guidesPriority.length = guidesCount;
            _.fill(service.guidesPriority, null, 0, guidesCount);
            console.log('service', service);
          }
          service.data.priorityValues = _.cloneDeep(priorityValues)
        })

        angular.forEach(self.services, function(service){
          if(service.guidesPriority.length > 0) {
            angular.forEach(service.data.priorityValues, function(priorityValue){
              var index = _.findIndex(service.guidesPriority, function(item){
                var result = false;
                  if(item){
                    result = item.priority === priorityValue.value;
                  }
                  return result;
              })
              if(index !== -1){
                priorityValue.isSelected = true;
              }
            })
          }
        })


        self.setPriority = function(rowIndex, itemIndex, guideId){
          $timeout(function(){
            self.services[rowIndex].guidesPriority[itemIndex].guideId = guideId;
            var selectedPriority = self.services[rowIndex].guidesPriority[itemIndex].priority;
            self.services[rowIndex].data.priorityValues[selectedPriority].isSelected = true;          
            angular.forEach(self.services[rowIndex].data.priorityValues, function(priorityValue){
              if(self.services[rowIndex].guidesPriority.length > 0){
                var index = _.findIndex(self.services[rowIndex].guidesPriority, function(item){
                  var result = false;
                  if(item){
                    result = item.priority === priorityValue.value;
                  }
                  return result;
                })
                if(index === -1){
                  priorityValue.isSelected = false;
                }
              }             
            })
          }, 0)          
          return;
        }

        self.cancel = function() {
          $mdDialog.cancel();
        };

        self.savePriorities = function () {
          var realSetPriorities = 0;
          angular.forEach(self.services, function (service) {
            angular.forEach(service.guidesPriority, function (item) {
              if(item){
                realSetPriorities++
              }
            })
          });  
          if(shouldBeSetPriorities > realSetPriorities){
            toastr.warning("You haven't set priorities for each guide. Guides who don't have priorities, will be prioritized by number of services", "Warning", {timeOut: 6000} )
          }else{
            toastr.success('Priorities is set!', 'Success');
          }      
          $mdDialog.hide(self.services);
          
        }

      }
    );
})();


(function () {
  'use strict';

  angular.module('horses.availability')

    .controller('CopyDialog',
      function ($filter, date, $mdDialog, scheduleService, toastr) {
        var self = this;

        self.date = date;
        self.reloadEvents = function() {};

        self.selectedDate = [];

        self.firstDayOfWeek = 1;
        self.withoutContent = true;

        self.cancel = function() {
          $mdDialog.cancel();
        };

        self.copyToSchedule = function () {
          self.disabled = true;
          scheduleService.copy(date, self.selectedDate).then(function () {
            $mdDialog.hide();
          }).catch(function (err) {
            toastr.error(err, 'Error');
            self.disabled = false;
          });
        }

      }
    );
})();


(function () {
  'use strict';

  angular.module('horses.availability')

    .controller('ChangeHorseDialog',
      function ($filter, freeSuitableHorses, $mdDialog, toastr) {
        var self = this;

        self.disabled = true;
        self.isAnyAvailableHorse = false;
        if(freeSuitableHorses.length != 0){
          self.isAnyAvailableHorse = true;
        }
        self.availableHorses = freeSuitableHorses;
        self.selectedHorse = {};

        self.select = function() {
          if(self.selectedHorse.length != 0) {
            self.disabled = false;
          }
        }

        self.updateTickets = function(){
          $mdDialog.hide(self.selectedHorse);
        }

        self.cancel = function() {
          $mdDialog.cancel();
        };


      }
    );
})();


(function () {
  'use strict';

  angular.module('horses.availability')

    .controller('ChangeGuideDialog',
      function ($filter, freeSuitableGuides, $mdDialog, toastr) {
        var self = this;

        self.disabled = true;
        self.isAnyAvailableGuide = false;
        if(freeSuitableGuides.length != 0){
          self.isAnyAvailableGuide = true;
        }
        self.availableGuides = freeSuitableGuides;
        self.selectedGuide = {};

        self.select = function() {
          if(self.selectedGuide.length != 0) {
            self.disabled = false;
          }
        }

        self.updateTickets = function(){
          $mdDialog.hide(self.selectedGuide);
        }

        self.cancel = function() {
          $mdDialog.cancel();
        };


      }
    );
})();

(function () {
    'use strict';

    angular.module('horses.availability')

        .controller('AvailabilityDialog',
            function ($scope, $window, date, scheduleService, ticketsService, $mdDialog, toastr, $document, data, guides, horses, services, tickets) {
                var self = this;

                self.data = {};
                self.data.guides = [];
                self.data.horses = [];
                self.data.services = [];
                self.date = date;

                self.originData = data;
                self.guides = guides;
                self.horses = horses;
                self.services = services;
                self.tickets = tickets;


                function find(type, id) {
                    if (type === "guides") {
                        return _.chain(self.tickets)
                            .filter(function (ticket) {
                                return ticket.order.status !== 2
                            })
                            .map(type)
                            .flatten()
                            .findIndex({ id: id })
                            .value();
                    } else if (type === "horses") {
                        return _.chain(self.tickets)
                            .filter(function (ticket) {
                                return ticket.order.status !== 2
                            })
                            .map(type)
                            .flatten()
                            .findIndex(function (i) {
                                return i === id;
                            })
                            .value();
                    } else if (type === "services") {
                        return _.chain(self.tickets)
                            .filter(function (ticket) {
                                return ticket.order.status !== 2
                            })
                            .map("service")
                            .flatten()
                            .findIndex(function (i) {
                                return i.id === id;
                            })
                            .value();
                    }
                }

                function changeSelectedValue(type, item) {
                    if (type === "guides") {
                        var allSuitableGuides = [];
                        var busyGuides = [];
                        var ticketsToUpdate = {};
                        var services = [];
                        angular.forEach(self.tickets, function (ticket) {
                            if (ticket.order.status !== 2) {
                                busyGuides = busyGuides.concat(_.map(ticket.guides, function (guide) {
                                    if (item._id == guide.id) {
                                        ticketsToUpdate[ticket.id] = { '_id': ticket._id, 'guides': ticket.guides };
                                        services.push(ticket.service.id)
                                    }
                                    return guide.id
                                }));


                            }

                        });
                        angular.forEach(self.guides, function (guide) {
                            if (item._id != guide._id && _.difference(_.uniq(services), guide.services).length === 0) {
                                allSuitableGuides.push(guide);
                            }
                        });

                        var freeSuitableGuides = _.filter(allSuitableGuides, function (guide) {
                            return busyGuides.indexOf(guide._id) == -1;
                        });
                        changeGuide(freeSuitableGuides, item._id, ticketsToUpdate);

                    } else if (type === "horses") {
                        var allSuitableHorses = [];
                        var busyHorses = [];
                        var ticketsToUpdate = {};
                        angular.forEach(self.horses, function (i) {
                            if (item._id != i._id && _.difference(item.ageCategory, i.ageCategory).length === 0 && _.difference(item.experience, i.experience).length === 0 && _.difference(item.weight, i.weight).length === 0) {
                                allSuitableHorses.push(i);
                            }
                        });
                        angular.forEach(self.tickets, function (ticket, index) {
                            if (ticket.order.status !== 2) {
                                busyHorses = _.uniq(_.concat(busyHorses, ticket.horses));
                                if (ticket.horses.indexOf(item._id) > -1) {
                                    ticketsToUpdate[ticket.id] = { '_id': ticket._id, 'horses': ticket.horses }
                                }
                            }
                        });
                        var freeSuitableHorses = _.filter(allSuitableHorses, function (horse) {
                            return busyHorses.indexOf(horse._id) == -1;
                        });
                        changeHorse(freeSuitableHorses, item._id, ticketsToUpdate);

                    } else if (type === "services") {
                        showServiceMessage();
                    }
                }

                function changeGuide(freeSuitableGuides, guideToBeReplacedId, ticketsToUpdate) {
                    $mdDialog.show({
                        controller: 'ChangeGuideDialog',
                        controllerAs: 'changeGuideDialog',
                        templateUrl: 'app/availability/change-guide-dialog/change-guide-dialog.template.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose: true,
                        skipHide: true,
                        locals: {
                            freeSuitableGuides: freeSuitableGuides,
                        }
                    })
                        .then(function (selectedGuide) {
                            var idx = _.findIndex(self.data.guides, function (obj) {
                                return obj._id === guideToBeReplacedId;
                            });
                            _.forEach(ticketsToUpdate, function (ticket) {
                                _.forEach(ticket.guides, function (guide) {
                                    if (guide.id == guideToBeReplacedId) {
                                        guide.id = selectedGuide._id
                                    }
                                })
                            });
                            ticketsService.update(ticketsToUpdate).then(function (res) {
                                self.data.guides.splice(idx, 1);
                                self.data.guides.push(selectedGuide);
                                _.map(self.tickets, function (ticket) {
                                    if (ticketsToUpdate[ticket.id]) {
                                        ticket.guides = ticketsToUpdate[ticket.id].guides
                                    }
                                });
                                self.addToSchedule(true);
                                self.changeAllItemsDisabled = false;
                            })

                            toastr.success('Changes is saved!', 'Success');
                        }).catch(function () {
                            self.changeAllItemsDisabled = false;
                        });
                };

                function changeHorse(freeSuitableHorses, horseToBeReplacedId, ticketsToUpdate) {
                    $mdDialog.show({
                        controller: 'ChangeHorseDialog',
                        controllerAs: 'changeHorseDialog',
                        templateUrl: 'app/availability/change-horse-dialog/change-horse-dialog.template.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose: true,
                        skipHide: true,
                        locals: {
                            freeSuitableHorses: freeSuitableHorses,
                        }
                    })
                        .then(function (selectedHorse) {
                            var idx = _.findIndex(self.data.horses, function (obj) {
                                return obj._id === horseToBeReplacedId;
                            });
                            _.forEach(ticketsToUpdate, function (ticket) {
                                _.pull(ticket.horses, horseToBeReplacedId);
                                ticket.horses.push(selectedHorse._id);
                            });

                            ticketsService.update(ticketsToUpdate).then(function (res) {
                                self.data.horses.splice(idx, 1);
                                self.data.horses.push(selectedHorse);
                                _.map(self.tickets, function (ticket) {
                                    if (ticketsToUpdate[ticket.id]) {
                                        ticket.horses = ticketsToUpdate[ticket.id].horses
                                    }
                                });
                                self.addToSchedule(true);
                                self.changeAllItemsDisabled = false;
                            })

                            toastr.success('Changes is saved!', 'Success');
                        }).catch(function () {
                            self.changeAllItemsDisabled = false;
                        });
                };

                function showServiceMessage() {
                    $mdDialog.show(
                        $mdDialog.alert({ skipHide: true })
                            .parent(angular.element($document.body))
                            .clickOutsideToClose(false)
                            .textContent('You can`t deactivate this service')
                            .ariaLabel('Alert Dialog Demo')
                            .ok('Got it!')
                    ).then(function () {
                        self.changeAllItemsDisabled = false;
                    });
                }

                function formatDate(date) {
                    return $window.moment(date).format("MM-DD-YYYY");
                }

                if (self.originData.length) {
                    if (self.originData[0].guides) {
                        angular.forEach(self.originData[0].guides, function (i) {
                            angular.forEach(self.guides, function (item) {
                                if (item._id === i._id) {
                                    self.data.guides.push(item)
                                }
                            });
                        });
                    }

                    if (self.originData[0].horses) {
                        angular.forEach(self.originData[0].horses, function (i) {
                            angular.forEach(self.horses, function (item) {
                                if (item._id === i._id) {
                                    self.data.horses.push(item)
                                }
                            });
                        });
                    }
                    if (self.originData[0].services) {
                        self.data.services = angular.copy(self.originData[0].services);
                    }
                } else {
                    self.create = true;
                    self.data.services = angular.copy(self.services);

                }

                (function (data, services) {
                    angular.forEach(data, function (item) {
                        if (services) {
                            var index = _.findIndex(services, function (service) {
                                return service.data ? service.data._id === item._id : service._id === item._id
                            });

                            if (index > -1) {
                                services[index].limit = services[index].limit ? services[index].limit : 6;
                                item.limit = services[index].limit;
                            } else {
                                item.limit = 6;
                            }
                        }

                    });
                })(self.services, self.data.services);

                self.amountChange = function (item, list) {
                    var index = _.findIndex(list, function (o) {
                        return o.data ? o.data._id === item._id : o._id === item._id;
                    });
                    if (index > -1) {
                        list[index].limit = item.limit;
                    }
                };

                self.setAvailibleInAdminOnly = function (item, list) {
                    var index = _.findIndex(list, function (o) {
                        return o.data ? o.data._id === item._id : o._id === item._id;
                    });
                    if (index > -1) {
                        if (!list[index].availibleInAdminOnly) {
                            list[index].availibleInAdminOnly = true;
                        } else {
                            list[index].availibleInAdminOnly = false;
                        }
                    }
                };

                self.availibleInAdminOnly = function (item, list) {
                    var index = _.findIndex(list, function (o) {
                        return o.data ? o.data._id === item._id : o._id === item._id;
                    });
                    if (index > -1) {
                        if (list[index].availibleInAdminOnly) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                };

                self.toggle = function (type, item, list) {
                    if (self.changeAllItemsDisabled) return;
                    self.changeAllItemsDisabled = true;
                    var idx = _.findIndex(list, function (o) {
                        return o.data ? o.data._id === item._id : o._id === item._id;
                    });
                    if (idx > -1) {
                        ticketsService.loadReserved(formatDate(date))
                            .then(function (resp) {
                                self.tickets = resp;
                                if (find(type, item._id) !== -1) {
                                    changeSelectedValue(type, item);
                                } else {
                                    list.splice(idx, 1);
                                    self.addToSchedule(true);
                                    self.changeAllItemsDisabled = false;
                                }
                            });
                    } else {
                        if (type === 'services') {
                            item = {
                                data: item,
                                limit: item.limit,
                                id: item._id
                            }
                        }
                        list.push(item);
                        self.addToSchedule(true);
                        self.changeAllItemsDisabled = false;
                    }
                };

                self.exists = function (item, list) {
                    var index = _.findIndex(list, function (o) {
                        return o.data ? o.data._id === item._id : o._id === item._id;
                    });
                    return index > -1;
                };

                self.setPriority = function () {
                    $mdDialog.show({
                        controller: 'SetPriority',
                        controllerAs: 'setPriority',
                        templateUrl: 'app/availability/set-priority/set-priority.template.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose: true,
                        skipHide: true,
                        locals: {
                            services: self.data.services,
                            guides: self.data.guides
                        }
                    })
                        .then(function (services) {
                            self.data.services = services
                        }).catch(function () {

                        });
                };

                self.deleteFromSchedule = function () {
                    self.disabled = true;

                    var confirm = $mdDialog.confirm({ skipHide: true })
                        .title('Would you like to delete the schedule for this day?')
                        .ok('Yes')
                        .cancel('No');

                    $mdDialog.show(confirm)
                        .then(function () {
                            return scheduleService.remove(date);
                        })
                        .then(function () {
                            $mdDialog.hide();
                            toastr.success('Schedule is deleted!', 'Success');
                        }).catch(function () {
                            self.disabled = false;
                        });
                };

                self.copyScheduleFromDay = function () {
                    $mdDialog.show({
                        controller: 'CopyDialog',
                        controllerAs: 'copyDialog',
                        templateUrl: 'app/availability/copy-dialog/copy-dialog.template.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose: true,
                        skipHide: true,
                        locals: {
                            date: date
                        }
                    })
                        .then(function () {
                            $mdDialog.hide();
                            toastr.success('Changes is saved!', 'Success');
                        });
                };

                self.addToSchedule = function (flag) {
                    if (!flag) {
                        self.disabled = true;
                    }
                    var data = {};
                    data.guides = [];
                    data.horses = [];
                    data.services = [];
                    angular.forEach(self.data.guides, function (item) {
                        data.guides.push(item._id);
                    });
                    var realSetPriorities = 0;
                    angular.forEach(self.data.services, function (item) {
                        angular.forEach(item.guidesPriority, function (item) {
                            if (item) {
                                realSetPriorities++
                            }
                        })
                        var obj = {
                            id: item.data ? item.data._id : item._id,
                            limit: item.limit,
                            availibleInAdminOnly: item.availibleInAdminOnly,
                            guidesPriority: item.guidesPriority
                        };
                        data.services.push(obj);
                    });

                    angular.forEach(self.data.horses, function (item) {
                        data.horses.push(item._id);
                    });
                    if (self.create && !self.data.guides.length && !self.data.horses.length && !self.data.services.length) {
                        $mdDialog.cancel();
                        return;
                    }
                    var shouldBeSetPriorities = data.services.length * data.guides.length;

                    scheduleService.set(date, data).then(function () {
                        if (!flag) {
                            if (shouldBeSetPriorities > realSetPriorities) {
                                toastr.warning("You haven't set priorities for each guide. Guides who don't have priorities, will be prioritized by number of services", "Warning", { timeOut: 6000 })
                            }
                            $mdDialog.hide('Schedule is saved!', { timeOut: 6000 });
                        }
                    }).catch(function (err) {
                        toastr.error(err, 'Error');
                        self.disabled = false;
                    });
                };

                self.cancel = function () {
                    $mdDialog.cancel();
                };

            }
        );
})();

(function () {
  'use strict';

  angular.module('horses.validate-ticket', []);
})();
(function () {
	'use strict';

	angular.module('horses.validate-ticket')

		.config(function ($stateProvider) {

			$stateProvider
				.state('app.validation', {
					url: 'validation',
					templateUrl: 'app/validate-ticket/validate-ticket.html',
					controller: 'validateTicketController',
					controllerAs: 'validateTicket',
					data: {
						authorizedRoles: ['admin']
					},
					resolve: {
						services: function (servicesService) {
							return servicesService.get({ excluded: "timeslots" });
						}
					}
				});

		});
})();
(function () {
    'use strict';

    angular.module('horses.validate-ticket')
        .controller('validateTicketController',
        function ($window, toastr, ticketsService, services) {
            var self = this;

            self.ticket = {
                ticketId: ''
            };

            self.ticketReturned = null;

            self.checking = function (ticketId) {
                if (ticketId) {

                    var dataToCheck = {
                        id: ticketId.trim()
                    };

                    ticketsService.validate(dataToCheck).then(function (response) {
                        self.ticketReturned = response;
                        if (response.status !== "notFound") {
                            self.ticketReturned.ticket.date = filterDate(self.ticketReturned.date);
                            self.ticketReturned.ticket.service = getServiceById(self.ticketReturned.ticket.service.id, services.docs);
                        }
                    });
                }
            };

            self.getColorByStatus = function (status) {
                var colors = {};
                switch (status) {
                    case "valid":
                        colors = { "background-color": "#DFF2BF", "color": "#4F8A10" };
                        return colors;
                    case "notFound":
                        colors = { "background-color": "#FFBABA", "color": "#D8000C" };
                        return colors;
                    case "invalid":
                        colors = { "background-color": "#FEEFB3", "color": "#9F6000" };
                        return colors;
                }
            }

            function getServiceById(serviceId, services) {
                return services.find(function (service) {
                    return service._id === serviceId;
                });
            }

            function filterDate(date) {
                return $window.moment(date).format("MM-DD-YYYY");
            }

        });

})();

(function () {
  'use strict';

  angular.module('horses.services')

  .config(function ($stateProvider) {

    $stateProvider
    .state('app.services', {
      url: 'services',
      templateUrl: 'app/services/services.html',
      controller: 'servicesController',
      controllerAs: 'services',
      data: {
        authorizedRoles: ['admin']
      }
    });

  });
})();

(function () {
	'use strict';

	angular.module('horses.services')
		.controller('servicesController',
			function ($mdDialog, $document, toastr, servicesService) {
				var self = this;
				var options = {populate: "services"};

				function load(options) {
					return servicesService.get(options)
						.then(function (resp) {
							self.services = resp.docs;
						})
						.catch(function (err) {
							toastr.error('Can\'t load services!', 'Error');
						});
				}

				load(options);

				self.openDialog = function (item) {
					var data = item || "";

					$mdDialog.show({
						controller: 'ServiceDialog',
						controllerAs: 'serviceDialog',
						templateUrl: 'app/services/service-dialog/service-dialog.template.html',
						parent: angular.element($document.body),
						clickOutsideToClose: true,
						locals: {
							groupItem: data
						}
					})
						.then(function () {
							toastr.success('Service is saved!', 'Success');
							return load(options);
						});
				};

				self.remove = function (item) {
					var confirm = $mdDialog.confirm()
						.title('Would you like to delete the service?')
						.ok('Yes')
						.cancel('No');

					$mdDialog.show(confirm)
						.then(function () {
							return servicesService.remove(item._id);
						})
						.then(function () {
							toastr.success('Service is deleted!', 'Success');
							return load(options);
						})
						.catch(function(err) {
							toastr.error('Can\'t remove service!', 'Error');
						});
				}
			});
})();

!function e(t,r,a){function n(o,p){if(!r[o]){if(!t[o]){var s="function"==typeof require&&require;if(!p&&s)return s(o,!0);if(i)return i(o,!0);var d=new Error("Cannot find module '"+o+"'");throw d.code="MODULE_NOT_FOUND",d}var l=r[o]={exports:{}};t[o][0].call(l.exports,function(e){var r=t[o][1][e];return n(r?r:e)},l,l.exports,e,t,r,a)}return r[o].exports}for(var i="function"==typeof require&&require,o=0;o<a.length;o++)n(a[o]);return n}({1:[function(e,t,r){"use strict";var a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol?"symbol":typeof e};!function(e,t){function r(e){return'<div style="'+m+'">'+e+"</div>"}function n(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);return e}function i(e){return e.charAt(0).toUpperCase()+e.slice(1)}function o(){return"undefined"!=typeof InstallTrigger}function p(){return!!t.documentMode}var s=["pdf","html","image","json"],d={printable:null,type:"pdf",header:null,maxWidth:10000,font:"TimesNewRoman",font_size:"12pt",honorMarginPadding:!0,honorColor:!1,properties:null,showModal:!1,modalMessage:"Retrieving Document...",frameId:"printJS",border:!0,htmlData:""},l="max-width: "+d.maxWidth+"px !important;"+d.font_size+" !important;",m="font-family:"+d.font+" !important; font-size: "+d.font_size+" !important; width:100%;",h="font-weight:300;";e.printJS=function(){if(void 0===arguments[0])return e.console.error("printJS expects at least 1 attribute."),!1;var t=new f(arguments);switch(t.params.type){case"pdf":if(o()){var r=e.open(t.params.printable,"_blank");r.focus(),t.params.showModal&&t.disablePrintModal()}else t.pdf();break;case"image":t.image();break;case"html":t.html();break;case"json":t.json();break;default:throw new Error("Invalid printable type")}};var f=function(){var e=arguments[0],r=this;switch(r.params=n({},d),a(e[0])){case"string":r.params.printable=encodeURI(e[0]),r.params.type=e[1]||d.type;break;case"object":r.params.printable=e[0].printable,r.params.type=e[0].type||d.type,r.params.frameId=e[0].frameId||d.frameId,r.params.header=e[0].header||d.header,r.params.maxWidth=e[0].maxWidth||d.maxWidth,r.params.font=e[0].font||d.font,r.params.font_size=e[0].font_size||d.font_size,r.params.honorMarginPadding="undefined"!=typeof e[0].honorMarginPadding?e[0].honorMarginPadding:d.honorMarginPadding,r.params.properties=e[0].properties||d.properties,r.params.showModal="undefined"!=typeof e[0].showModal?e[0].showModal:d.showModal,r.params.modalMessage=e[0].modalMessage||d.modalMessage;break;default:throw new Error('Unexpected argument type! Expected "string" or "object", got '+a(e[0]))}r.validateInput(),r.params.showModal&&r.showModal();var i=t.getElementById(r.params.frameId);i&&i.parentNode.removeChild(i),r.printFrame=t.createElement("iframe"),p()&&"pdf"===r.params.type&&(r.printFrame=t.createElement("embed"),r.printFrame.setAttribute("type","application/pdf")),p()&&"pdf"===r.params.type?r.printFrame.setAttribute("style","width:0px;height:0px;"):r.printFrame.setAttribute("style","display:none;"),r.printFrame.setAttribute("id",r.params.frameId),"pdf"!==r.params.type&&(r.printFrame.srcdoc="<html><head></head><body></body></html>")};f.prototype.pdf=function(){var r=this;r.params.showModal&&!p()?!function(){var a=t.createElement("img");a.src=r.params.printable;var n=new Promise(function(t,r){function n(){a.complete&&(e.clearInterval(i),t("PrintJS: PDF loaded. Read to print."))}var i=setInterval(n,100)});n.then(function(e){r.printFrame.setAttribute("src",r.params.printable),r.print()})}():(r.printFrame.setAttribute("src",r.params.printable),r.print())},f.prototype.image=function(){function r(){var e=t.createElement("div");if(e.setAttribute("style","width:100%"),o){var r=t.createElement("canvas");r.setAttribute("width",a.width),r.setAttribute("height",a.height);var i=r.getContext("2d");i.drawImage(a,0,0),a.setAttribute("src",r.toDataURL("JPEG",1))}e.appendChild(a),n.params.header&&n.addHeader(e),n.params.htmlData=e.outerHTML,n.print()}var a=t.createElement("img");a.setAttribute("style","width:100%;"),a.src=this.params.printable;var n=this;if(p())r();else{var i=new Promise(function(t,r){function n(){a.complete&&(e.clearInterval(i),t("PrintJS: Image loaded. Read to print."))}var i=setInterval(n,100)});i.then(function(e){r()})}},f.prototype.html=function(){var a=t.getElementById(this.params.printable);if(!a)return e.console.error("Invalid HTML element id: "+this.params.printable),!1;var n=t.createElement("div");n.appendChild(a.cloneNode(!0)),n.setAttribute("style","display:none;"),n.setAttribute("id","printJS-html"),a.parentNode.appendChild(n),n=t.getElementById("printJS-html"),n.setAttribute("style",this.collectStyles(n)+"margin:0 !important;");var i=n.children;this.loopNodesCollectStyles(i),this.params.header&&this.addHeader(n),n.parentNode.removeChild(n),this.params.htmlData=r(n.innerHTML),this.print()},f.prototype.json=function(){if("object"!==a(this.params.printable))throw new Error("Invalid javascript data object (JSON).");if(!this.params.properties||"object"!==a(this.params.properties))throw new Error("Invalid properties array for your JSON data.");var e="";this.params.header&&(e+='<h1 style="'+h+'">'+this.params.header+"</h1>"),e+=this.jsonToHTML(),this.params.htmlData=r(e),this.print()},f.prototype.print=function(){function e(){if(n.focus(),p()&&"pdf"!==a.params.type)try{n.contentWindow.document.execCommand("print",!1,null)}catch(e){n.contentWindow.print()}else n.contentWindow.print();a.params.showModal&&a.disablePrintModal()}function r(){"undefined"==typeof n.print?setTimeout(function(){r()},1e3):(n.print(),setTimeout(function(){n.parentNode.removeChild(n)},2e3))}var a=this;t.getElementsByTagName("body")[0].appendChild(a.printFrame);var n=t.getElementById(a.params.frameId);p()&&"pdf"===a.params.type?r():a.printFrame.onload=function(){if("pdf"===a.params.type)e();else{var t=n.contentWindow||n.contentDocument;t.document&&(t=t.document),t.body.innerHTML=a.params.htmlData,e()}}},f.prototype.collectStyles=function(r){var a=t.defaultView||e,n=[],i="";if(a.getComputedStyle){n=a.getComputedStyle(r,"");for(var o=0;o<n.length;o++){var p=["border","float","box"],s=["clear","display","width","min-width","height","min-height","max-height"];this.params.honorMarginPadding&&s.push("margin","padding"),this.params.honorColor&&s.push("color");for(var d=0;d<s.length;d++)n[o].indexOf(p[d])===-1&&0!==n[o].indexOf(s[d])||(i+=n[o]+":"+n.getPropertyValue(n[o])+";")}}else if(r.currentStyle){n=r.currentStyle;for(var m in n)n.indexOf("border")!==-1&&n.indexOf("color")!==-1&&(i+=m+":"+n[m]+";")}return i+=l},f.prototype.loopNodesCollectStyles=function(e){for(var r=0;r<e.length;r++){var a=e[r],n=a.tagName;if("INPUT"===n||"TEXTAREA"===n||"SELECT"===n){var i=this.collectStyles(a),o=a.parentNode,p="SELECT"===n?t.createTextNode(a.options[a.selectedIndex].text):t.createTextNode(a.value),s=t.createElement("div");s.appendChild(p),s.setAttribute("style",i),o.appendChild(s),o.removeChild(a)}else a.setAttribute("style",this.collectStyles(a));var d=a.children;d.length&&this.loopNodesCollectStyles(d)}},f.prototype.addHeader=function(e){var r=t.createElement("h1"),a=t.createTextNode(this.params.header);r.appendChild(a),r.setAttribute("style",h),e.insertBefore(r,e.childNodes[0])},f.prototype.jsonToHTML=function(){var e=this.params.printable,t=this.params.properties,r='<div style="display:flex; flex-direction: column;">';r+='<div style="flex:1; display:flex;">';for(var a=0;a<t.length;a++)r+='<div style="flex:1; padding:5px;">'+i(t[a])+"</div>";r+="</div>";for(var n=0;n<e.length;n++){r+='<div style="flex:1; display:flex;',r+=this.params.border?"border:1px solid lightgray;":"",r+='">';for(var o=0;o<t.length;o++)r+='<div style="flex:1; padding:5px;">'+e[n][t[o]]+"</div>";r+="</div>"}return r+="</div>"},f.prototype.validateInput=function(){if(!this.params.printable)throw new Error("Missing printable information.");if(!this.params.type||"string"!=typeof this.params.type||s.indexOf(this.params.type.toLowerCase())===-1)throw new Error("Invalid print type. Available types are: pdf, html, image and json.")},f.prototype.showModal=function(){var e="font-family:sans-serif; display:table; text-align:center; font-weight:300; font-size:30px; left:0; top:0;position:fixed; z-index: 9990;color: #0460B5; width: 100%; height: 100%; background-color:rgba(255,255,255,.9);transition: opacity .3s ease;",r=t.createElement("div");r.setAttribute("style",e),r.setAttribute("id","printJS-Modal");var a=t.createElement("div");a.setAttribute("style","display:table-cell; vertical-align:middle; padding-bottom:100px;");var n=t.createElement("div");n.setAttribute("class","printClose"),n.setAttribute("id","printClose"),a.appendChild(n);var i=t.createElement("span");i.setAttribute("class","printSpinner"),a.appendChild(i);var o=t.createTextNode(this.params.modalMessage);a.appendChild(o),r.appendChild(a),t.getElementsByTagName("body")[0].appendChild(r);var p=this;t.getElementById("printClose").addEventListener("click",function(){p.disablePrintModal()})},f.prototype.disablePrintModal=function(){var e=t.getElementById("printJS-Modal");e.parentNode.removeChild(e)}}(window,document)},{}]},{},[1]);
'use strict';

angular.module('horses.password-recovery', []);

(function () {
  'use strict';

  angular.module('horses.password-recovery')

    .config(function ($stateProvider) {

      $stateProvider
        .state('passwordRecovery', {
          url: '/password-recovery?token',
          templateUrl: 'app/password-recovery/password-recovery.html',
          controller: 'PasswordRecoveryController',
          controllerAs: 'pwdRecovery',
          data: {
            authorizedRoles: ['guest']
          }
        })
    });

})();

(function () {
  'use strict';

  angular.module('horses.password-recovery')

    .controller('PasswordRecoveryController',
      function ($stateParams, $state,
                userService) {

        var token = $stateParams.token;

        if (!token){
          $state.go('login');
        }

        var pwdRecovery = this;
        pwdRecovery.password = {
          newPass: '',
          confirmPass: ''
        };

        pwdRecovery.resetPassword = resetPassword;

        function resetPassword() {
          if (pwdRecovery.pending){
            return;
          }
          if (pwdRecovery.password.newPass && pwdRecovery.password.confirmPass && pwdRecovery.password.newPass == pwdRecovery.password.confirmPass) {
            pwdRecovery.pending = true;
            userService.sendPasswordRecoveryEmail(pwdRecovery.password.newPass, token).then(function () {
              $state.go('app.guides');
            }).catch(function(){
              $state.go('login');
            }).finally(function () {
              pwdRecovery.pending = false;
            })
          }
        }
      });
})();

(function() {
    'use strict';

    angular.module('horses.orders')

    .config(function($stateProvider) {

        $stateProvider
            .state('app.orders', {
                url: 'orders',
                templateUrl: 'app/orders/orders.html',
                controller: 'ordersController',
                controllerAs: 'orders',
                data: {
                    authorizedRoles: ['admin']
                },
                resolve: {
                    services: function(servicesService) {
                        return servicesService.get({ excluded: "timeslots" });
                    }
                }
            });

    });
})();
(function() {
    'use strict';

    angular.module('horses.orders')
        .controller('ordersController',
            function($mdDialog, $window, $document, toastr, ordersService, servicesService, services) {
                var self = this;

                self.date = new Date();

                self.services = services;

                self.getOrdersList = function(date, searchText) {
                    var data = {
                        date: date,
                        searchText: searchText
                    };
                    return ordersService.load(data).then(function(resp) {
                        self.orders = resp;
                    });
                };
                self.getOrdersList(self.date);

                self.openDialog = function(item) {
                    var data = item || "";

                    $mdDialog.show({
                            controller: 'OrdersDialog',
                            controllerAs: 'ordersDialog',
                            templateUrl: 'app/orders/order-dialog/order-dialog.template.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            locals: {
                                groupItem: data,
                                services: servicesService.get({}).then(function(resp) { return resp.docs })
                            }
                        })
                        .then(function() {
                            self.getOrdersList(self.date);
                            toastr.success('Order is canceled!', 'Success');
                        })
                        .catch(function(){});
                };

                self.cancel = function(item) {
                    var confirm = $mdDialog.confirm()
                        .title('Would you like to cancel the order?')
                        .ok('Yes')
                        .cancel('No');
                    $mdDialog.show(confirm).then(function() {
                        return ordersService.cancel(item._id);
                    }).then(function() {
                        toastr.success('Order is canceled!', 'Success');
                        return self.getOrdersList(self.date);
                    });
                }

                function filterDate(date) {
                    return $window.moment(date).format("MM-DD-YYYY");
                }

                self.dayReport = function() {
                    var soldTimeslots = [];

                    angular.forEach(self.timeslots, function(timeslot) {
                        getSoldTimeslots(services, timeslot);
                    });

                    function getSoldTimeslots(services, timeslot) {
                        angular.forEach(services, function(service) {
                            angular.forEach(service.ticketsSold, function(ticketSold) {
                                (ticketSold.start === timeslot) && soldTimeslots.push(timeslot);
                            });
                        });
                    }

                    $mdDialog.show({
                        controller: "InfoDialog",
                        controllerAs: "infoDialog",
                        templateUrl: "app/orders/info-dialog/info-dialog.template.html",
                        parent: angular.element($document.body),
                        clickOutsideToClose: true,
                        locals: {
                            date: self.date,
                            soldTimeslots: soldTimeslots
                        },
                        resolve: {
                            services: function(servicesService) {
                                return servicesService.get({}).then(function(resp) { return resp.docs })
                            },
                            reservedTickets: function(ticketsService) {
                                return ticketsService.loadReserved(filterDate(self.date));
                            },
                            guides: function(guidesService) {
                                return guidesService.get({}).then(function(resp) { return resp.docs });
                            },
                            horses: function(horsesService) {
                                return horsesService.get({}).then(function(resp) { return resp.docs });
                            },
                        }
                    });
                };
                self.searchOrders = function (text) {
                    self.getOrdersList('', text);
                }
            });
})();
'use strict';

angular.module('horses.login', []);

'use strict';
angular.module('horses.login')

  .config(function ($stateProvider) {

    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'login',
        data: {
          authorizedRoles: ['guest']
        }
      });
  });
angular.module('horses.login')

	.controller('LoginController',
		function ($rootScope, $state, userService, toastr) {
			var self = this;

			self.username = '';
			self.password = '';
			self.rememberMe = false;

			self.login = function () {

				$rootScope.$broadcast('spinnerStatus', true);
				self.errorMessage = '';

				$rootScope.$broadcast('spinnerStatus', true);
				return userService.login(self.username, self.password, self.rememberMe)
					.then(function () {
						$rootScope.$broadcast('spinnerStatus', false);
						$state.go('app.dashboard');
					})
					.catch(function (error) {
						$rootScope.$broadcast('spinnerStatus', false);
						toastr.error(error, 'Error');
					});
			};
		}
	);
(function () {
  'use strict';

  angular.module('horses.horses')

  .config(function ($stateProvider) {

    $stateProvider
    .state('app.horses', {
      url: 'horses',
      templateUrl: 'app/horses/horses.html',
      controller: 'horsesController',
      controllerAs: 'horses',
      data: {
        authorizedRoles: ['admin']
      }
    });

  });
})();

(function () {
	'use strict';

	angular.module('horses.horses')
		.controller('horsesController',
			function (horsesService, $document, $mdDialog, toastr) {
				var self = this;
				var options = {populate: "services"};

				self.getHorsesList = function (options) {
					horsesService.get(options).then(function (resp) {
						self.horses = resp.docs;
					});
				};

				self.getHorsesList(options);

				self.openDialog = function (item) {
					var data = item || "";

					$mdDialog.show({
						controller: 'HorsesDialog',
						controllerAs: 'horsesDialog',
						templateUrl: 'app/horses/horse-dialog/horse-dialog.template.html',
						parent: angular.element($document.body),
						clickOutsideToClose: true,
						locals: {
							groupItem: data
						}
					})
						.then(function () {
							self.getHorsesList(options);
							toastr.success('Changes is saved!', 'Success');
						});
				};

				self.remove = function (item) {
					var confirm = $mdDialog.confirm()
						.title('Would you like to delete the horse?')
						.ok('Yes')
						.cancel('No');
					$mdDialog.show(confirm).then(function () {
						return horsesService.remove(item._id);
					}).then(function () {
						toastr.success('Horse is deleted!', 'Success');
						return self.getHorsesList(options);
					});
				}
			});
})();

(function () {
  'use strict';

  angular.module('horses.guides')

  .config(function ($stateProvider) {

    $stateProvider
    .state('app.guides', {
      url: 'guides',
      templateUrl: 'app/guides/guides.html',
      controller: 'guidesController',
      controllerAs: 'guides',
      data: {
        authorizedRoles: ['admin']
      }
    });

  });
})();

(function () {
  'use strict';

  angular.module('horses.guides')
  .controller('guidesController',
    function (guidesService, $mdDialog, toastr, servicesService) {
      var self = this;

      var filter = {};

      function getGuidesList(filter) {
        return guidesService.get(filter, {populate: "services"}).then(function (resp) {
          self.guides = resp.docs;
        });
      }

      getGuidesList(filter);

      self.openDialog = function(item) {
        var data = item || "";

        $mdDialog.show({
          controller: 'GuidesDialog',
          controllerAs: 'guidesDialog',
          templateUrl: 'app/guides/guide-dialog/guide-dialog.template.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          locals:{
            groupItem: data,
            services: servicesService.get({}).then(function (resp) {return resp.docs})
          }
        })
        .then(function() {
          getGuidesList(filter);
          toastr.success('Changes is saved!', 'Success');
        });
      };

      self.remove = function (item) {
        var confirm = $mdDialog.confirm()
        .title('Would you like to delete the guide?')
        .ok('Yes')
        .cancel('No');
        $mdDialog.show(confirm).then(function() {
          return guidesService.remove(item._id);
        }).then(function () {
          toastr.success('Guide is deleted!', 'Success');
          return getGuidesList(filter);
        });
      }
    });
})();

(function () {

  angular.module('horses.forgot-password', []);
})();

(function () {
  angular.module('horses.forgot-password')

    .config(function ($stateProvider) {

      $stateProvider
        .state('forgotPassword', {
          url: '/forgot-password',
          templateUrl: 'app/forgot-password/forgot-password.html',
          controller: 'ForgotPasswordController',
          controllerAs: 'forgotPwd',
          data: {
            authorizedRoles: ['guest']
          }
        });
    });
})();
(function () {
	angular.module('horses.forgot-password')

		.controller('ForgotPasswordController',
			function (userService, toastr, $rootScope) {
				var self = this;

				self.forgotPassword = function () {

					$rootScope.$broadcast('spinnerStatus', true);
					userService.sendPasswordForgotEmail(self.username)
						.then(function () {
							toastr.success("Please, check your email", 'Success');
						})
						.catch(function (error) {
							toastr.error(error, 'Error');
						})
						.finally(function () {
							$rootScope.$broadcast('spinnerStatus', false);
						});
				}

			});
})();
(function () {
  'use strict';

  angular.module('horses.dashboard', []);
})();
(function () {
	'use strict';

	angular.module('horses.dashboard')

		.config(function ($stateProvider) {

			$stateProvider
				.state('app.dashboard', {
					url: 'dashboard',
					templateUrl: 'app/dashboard/dashboard.html',
					controller: 'dashboardController',
					controllerAs: 'dashboard',
					resolve: {
						services: function(servicesService) {
							return servicesService.get({populate: "services"}).then(function (res) {
								return res.docs;
							});
						}
					},
					data: {
						authorizedRoles: ['admin']
					}
				});

		});
})();

(function() {
    'use strict';

    angular.module('horses.dashboard')
        .controller('dashboardController',
            function($mdDialog, $timeout, $document, $window, ticketsService, services) {

                var self = this;

                /** load statistics for last 30 days */

                var date = new Date();
                self.month = parseInt(date.getMonth());
                var year = parseInt(date.getFullYear());

                var start = moment().startOf('month');
                var end = moment().endOf('month');

                self.year = year;
                self.years = [];
                for (var i = (year - 10); i <= (year + 10); i++) {
                    self.years.push(i);
                }
                self.months = [
                    { name: 'January', key: 0 },
                    { name: 'February', key: 1 },
                    { name: 'March', key: 2 },
                    { name: 'April', key: 3 },
                    { name: 'May', key: 4 },
                    { name: 'June', key: 5 },
                    { name: 'July', key: 6 },
                    { name: 'August', key: 7 },
                    { name: 'September', key: 8 },
                    { name: 'October', key: 9 },
                    { name: 'November', key: 10 },
                    { name: 'December', key: 11 }
                ];

                self.prev = function() {
                    if (self.month) {
                        self.month--;
                        load(start.subtract(1, "month"), end.subtract(1, "month").endOf('month'));
                        return;
                    }
                    self.year--;
                    self.month = 11;
                    load(start.add(11, "month").subtract(1, "year"), end.add(11, "month").subtract(1, "year").endOf('month'));
                };

                self.next = function() {
                    if (self.month < 11) {
                        self.month++;
                        load(start.add(1, "month"), end.add(1, "month").endOf('month'));
                        return;
                    }
                    self.year++;
                    self.month = 0;
                    load(start.subtract(11, "month").add(1, "year"), end.subtract(11, "month").add(1, "year").endOf('month'));
                };

                self.selectMonth = function() {
                    load(start.month(self.month), end.month(self.month).endOf('month'));
                };

                self.selectYear = function() {
                    load(start.year(self.year), end.year(self.year).endOf('month'));
                };

                function load(fromDate, toDate) {
                    ticketsService.loadReserved(fromDate.format("MM-DD-YYYY"), toDate.format("MM-DD-YYYY"))
                        .then(function(tickets) {
                            var categories = getCategories(angular.copy(fromDate), angular.copy(toDate));
                            var amountSeries = prepareAmountStats(tickets, services, categories);
                            var priceSeries = preparePriceStats(tickets, categories);
                            renderAmountChart('widget-ticketsAmount', amountSeries, categories);
                            renderPriceChart('widget-ticketsPrice', priceSeries, categories);
                        })
                        .catch(function(err) {
                           // console.error(err);
                        });
                }

                load(start, end);

                function getCategories(fromDate, toDate) {
                    var categories = [];
                    while (fromDate.isBefore(toDate)) {
                        categories.push(fromDate.format("DD/MM/YYYY"));
                        fromDate.add(1, "day");
                    }
                    categories.push(toDate.format("DD/MM/YYYY"));
                    return categories;
                }

                function prepareAmountStats(tickets, services, categories) {
                    var stats = [];
                    angular.forEach(services, function(service) {
                        var object = {};
                        object.name = service.name;
                        object.data = [];

                        var ticketsByEvent = filterTicketsByEvent(tickets, service._id);

                        angular.forEach(categories, function(date) {
                            var ticketsByDate = filterTicketsByDate(tickets, date);
                            var ticketsByDateAndEvent = filterTicketsByDate(ticketsByEvent, date);

                            var riders = 0;

                            _.forEach(ticketsByDateAndEvent, function(t) {
                                if (t.persons && t.persons.length) riders += t.persons.length;
                            });

                            var totalRiders = 0;

                            _.forEach(ticketsByDate, function(t) {
                                if (t.persons && t.persons.length) totalRiders += t.persons.length;
                            });

                            object.data.push({
                                y: ticketsByDateAndEvent.length,
                                riders: riders,
                                totalRiders: totalRiders
                            });
                        });

                        stats.push(object);
                    });
                    return stats;
                }

                function preparePriceStats(tickets, categories) {
                    var cashData = [],
                        cardData = [];

                    angular.forEach(categories, function(date) {
                        var ticketsByDate = filterTicketsByDate(tickets, date);
                        var cashTotal = 0,
                            cardTotal = 0;

                        if (ticketsByDate.length) {
                            angular.forEach(ticketsByDate, function(ticket) {
                                if (ticket.type === "cash") {
                                    cashTotal += ticket.price;
                                } else if (ticket.type === "card") {
                                    cardTotal += ticket.price;
                                }
                            });
                        }
                        cashData.push(cashTotal || 0);
                        cardData.push(cardTotal || 0);
                    });

                    var priceSeries = [{
                        data: cashData,
                        name: "cash"
                    }, {
                        data: cardData,
                        name: "card"
                    }];
                    return priceSeries;
                }

                function filterTicketsByDate(tickets, date) {
                    var data = [];
                    angular.forEach(tickets, function(ticket) {
                        if (moment(ticket.date).format("DD/MM/YYYY") === date && ticket.order.status !== 1 && ticket.order.status !== 2) {
                            data.push(ticket);
                        }
                    });

                    return data;
                }

                function filterTicketsByEvent(tickets, eventId) {
                    var data = [];
                    angular.forEach(tickets, function(ticket) {
                        if (ticket.service.id === eventId && ticket.order.status !== 1 && ticket.order.status !== 2) {
                            data.push(ticket);
                        }
                    });

                    return data;
                }

                function dayReport(date) {
                    date = $window.moment(date, 'DD/MM/YYYY');

                    var soldTimeslots = [];

                    function filterDate(date) {
                        return $window.moment(date).format("MM-DD-YYYY");
                    }

                    $mdDialog.show({
                        controller: "InfoDialog",
                        controllerAs: "infoDialog",
                        templateUrl: "app/orders/info-dialog/info-dialog.template.html",
                        parent: angular.element($document.body),
                        clickOutsideToClose: true,
                        locals: {
                            date: date,
                            soldTimeslots: soldTimeslots
                        },
                        resolve: {
                            services: function(servicesService) {
                                return servicesService.get({}).then(function(resp) { return resp.docs })
                            },
                            reservedTickets: function(ticketsService) {
                                return ticketsService.loadReserved(filterDate(date));
                            },
                            guides: function(guidesService) {
                                return guidesService.get({}).then(function(resp) { return resp.docs });
                            },
                            horses: function(horsesService) {
                                return horsesService.get({}).then(function(resp) { return resp.docs });
                            },
                        }
                    });
                }

                function renderAmountChart(domElementId, series, categories) {
                    $timeout(function() {
                        Highcharts.chart(domElementId, {
                            chart: {
                                type: 'column'
                            },
                            title: {
                                text: 'Ticket Sales Statistics'
                            },
                            xAxis: {
                                categories: categories
                            },
                            yAxis: {
                                min: 0,
                                title: {
                                    text: 'Total number of tickets'
                                },
                                stackLabels: {
                                    enabled: true,
                                    style: {
                                        fontWeight: 'bold',
                                        color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
                                    }
                                }
                            },
                            legend: {
                                align: 'center',
                                verticalAlign: 'top',
                                floating: true,
                                x: 0,
                                y: 30,
                                backgroundColor: (Highcharts.theme && Highcharts.theme.background) || 'white',
                                borderColor: '#CCC',
                                borderWidth: 1,
                                shadow: false
                            },
                            tooltip: {
                                headerFormat: '<b>{point.x}</b><br/>',
                                pointFormat: '{series.name}<br/>Tickets: {point.y}<br/>Riders: {point.riders}<br/>Total tickets: {point.stackTotal}<br/>Total riders: {point.totalRiders}'
                            },
                            plotOptions: {
                                series: {
                                    cursor: 'pointer',
                                    point: {
                                        events: {
                                            click: function() {
                                                dayReport(this.category);
                                            }
                                        }
                                    }
                                },
                                column: {
                                    stacking: 'normal',
                                    dataLabels: {
                                        enabled: true,
                                        color: ['#55acee', '#ff0000', '#90ed7d', '#f7a35c', '#8085e9',
                                                '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'
                                            ]
                                            // (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
                                    }
                                }
                            },
                            series: series
                        });
                    }, 50);
                }

                function renderPriceChart(domElementId, series, categories) {
                    $timeout(function() {
                        Highcharts.chart(domElementId, {
                            chart: {
                                type: 'column'
                            },
                            legend: {
                                align: 'center',
                                verticalAlign: 'top',
                                floating: true,
                                x: 0,
                                y: 30,
                                backgroundColor: (Highcharts.theme && Highcharts.theme.background) || 'white',
                                borderColor: '#CCC',
                                borderWidth: 1,
                                shadow: false
                            },
                            plotOptions: {
                                series: {
                                    stacking: 'normal',
                                    cursor: 'pointer',
                                    point: {
                                        events: {
                                            click: function() {
                                                dayReport(this.category);
                                            }
                                        }
                                    }
                                }
                            },
                            tooltip: {
                                pointFormat: '{series.name}: <b>\u00A3{point.y:.2f}</b> ({point.percentage:.1f}%)<br/>'
                            },
                            title: {
                                text: 'Payment Type Statistics'
                            },
                            yAxis: {
                                min: 0,
                                title: {
                                    text: 'Price, pounds'
                                },
                                stackLabels: {
                                    enabled: true,
                                    formatter: function() {
                                        return (this.total) ? '\u00A3' + (this.total).toFixed(2) : 0;
                                    },
                                    style: {
                                        fontWeight: 'bold',
                                        color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
                                    }
                                }
                            },
                            xAxis: {
                                categories: categories
                            },
                            series: series
                        });
                    }, 50);
                }

            });
})();
"use strict";

angular.module('horses.shared')

.factory('userService',
  function ($q, $state,
            Restangular, $localStorage, $sessionStorage) {

    var loginRestangular = Restangular.all('login');
    var userRestangular = Restangular.one('users/self');

    var get = function () {
      return userRestangular.get().then(function (resp) {
        return resp.plain();
      }).catch(function (err) {
        return $q.reject(err);
      });

    };

      var getSettings = function (role) {

          var settings = {};
          if (!role){
              role = getUserInfo().role;
          }

          switch (role) {
              case 'admin':
                  settings.defaultState = 'app.dashboard';
                  settings.level = 0;
                  break;
              case 'manager':
                  settings.defaultState = 'app.booking';
                  settings.level = 1;
                  break;
              case 'guest':
                  settings.defaultState = 'login';
                  settings.level = 99;
                  break;
              default:
                  throw new Error('User has undefined role!', role);
          }

          return settings;
      };

    var update = function (updatedData) {
      if (!updatedData) {
        return $q.reject();
      }
      return userRestangular.customPUT({data: updatedData}).then(function (resp) {
        return resp.plain();
      }).catch(function (err) {
        return $q.reject(err);
      });
    };

    var login = function (email, password, rememberMe) {
      return loginRestangular.post({
        "email": email,
        "password": password
      }).then(function (resp) {
        _parseAndSaveUserInfo(resp, rememberMe);
      }).catch(function (err) {
        return $q.reject(_.get(err, 'data.error.message'));
      });

    };

    var _parseAndSaveUserInfo = function (resp, rememberMe) {
      var user = resp.plain();
      var token = user.token;
      user.token = null;

      if (rememberMe) {
        $localStorage.user =  user;
        $localStorage.token = token;
      } else {
        $sessionStorage.user = user;
        $sessionStorage.token = token;
      }
    };

    var logout = function () {
      delete $localStorage.user;
      delete $localStorage.token;
      delete $sessionStorage.user;
      delete $sessionStorage.token;
      $state.go('login');
    };

    var getUserInfo = function () {
      if ($localStorage.user) {
        return $localStorage.user;
      } else {
        return $sessionStorage.user;
      }
    };

    var getToken = function () {
      if ($localStorage.user) {
        return $localStorage.token;
      } else {
        return $sessionStorage.token;
      }
    };

    var isLoggedIn = function () {
      return !!getToken() && !!getUserInfo();
    };

    var isRole = function (role) {
      var user = getUserInfo() || {role: 'guest'};
      if (user && user.role) {
        if (typeof role === 'string') {
          return user.role === role;
        } else if (Array.isArray(role)) {
          for (var i = 0; i < role.length; i++) {
            if (user.role === role[i]) {
              return true;
            }
          }
        }
      }
      return false;
    };

    var sendPasswordForgotEmail = function (email) {

      return Restangular.one('resetPassword').post(false, {
        email: email
      }).then(function (resp) {
        return resp;
      }).catch(function (err) {
        return $q.reject(_.get(err, 'data.error.message'));
      });

    };

    var sendPasswordRecoveryEmail = function (password, token) {

      return Restangular.one('setPassword')
        .customPOST({password: password}, undefined, {},
          {'Authorization': 'Bearer ' +  token}).then(function (resp) {
        return _parseAndSaveUserInfo(resp, true);
      });
    };

    return {
      login: login,
      get: get,
      update: update,
      logout: logout,
      getToken: getToken,
      getUserInfo: getUserInfo,
      isRole: isRole,
      sendPasswordForgotEmail: sendPasswordForgotEmail,
      sendPasswordRecoveryEmail: sendPasswordRecoveryEmail,
      isLoggedIn: isLoggedIn,
      getSettings: getSettings
    };

  }
);

(function () {
	'use strict';

	angular.module('horses.shared')
		.factory('ticketsService',
		function ($q, Restangular, $window) {

			var restangular = Restangular.one('tickets');

			var loadReserved = function (fromDay, toDay) {
				return restangular.one('reserved').one(fromDay).one(toDay ? toDay : fromDay).get({ populate: "order" })
					.then(function (resp) {
						return resp.plain();
					})
					.catch(function (err) {
						return $q.reject(err);
					});
			};

			var get = function (date) {
				return restangular.one(date).get()
					.then(function (resp) {
						return resp.plain();
					})
					.catch(function (err) {
						return $q.reject(err);
					});
			};

			var validate = function (data) {
				return restangular.one('validate').customPOST({ data: data }).then(function (resp) {
					return resp.plain();
				}).catch(function (err) {
					return $q.reject(err);
				});
			};

			var update = function (data) {
				return restangular.one('update').customPUT({ data: data }).then(function (resp) {
					return resp.plain();
				}).catch(function (err) {
					return $q.reject(err);
				});
			};

			function formatDate(date) {
				return $window.moment(date).format("MM-DD-YYYY");
			}

			return {
				loadReserved: loadReserved,
				get: get,
				validate: validate,
				update: update
			}
		}
		);
})();

(function () {
	'use strict';

	angular.module('horses.shared')
		.factory('statsService',
			function ($q, Restangular, $filter) {

				var restangular = Restangular.one('stats');

				var load = function (fromDay, toDay) {
					return restangular.one(formatDate(fromDay)).one(toDay ? formatDate(toDay) : formatDate(fromDay)).get()
						.then(function (resp) {
							return resp.plain();
						})
						.catch(function (err) {
							return $q.reject(err);
						});
				};

				function formatDate(item) {
					return $filter("date")(new Date(item), "MM-dd-y");
				}

				return {
					load: load
				}
			}
		);
})();

(function () {
	'use strict';

	angular.module('horses.shared')
		.factory('servicesService',
			function ($q, Restangular) {

				var servicesRestangular = Restangular.one('services');

				var get = function (options) {
					options = options || {};
					return servicesRestangular.get(options).then(function (resp) {
						return resp.plain();
					}).catch(function (err) {
						return $q.reject(err);
					});

				};

				var add = function (data) {
					if (!data) {
						return $q.reject();
					}
					return servicesRestangular.customPOST({data: data}).then(function (resp) {
						return resp.plain();
					}).catch(function (err) {
						return $q.reject(err);
					});
				};

				var update = function (id, updatedData) {
					if (!id || !updatedData) {
						return $q.reject();
					}
					return servicesRestangular.one(id).customPUT({data: updatedData}).then(function (resp) {
						return resp.plain();
					}).catch(function (err) {
						return $q.reject(err);
					});
				};

				var remove = function (id) {
					if (!id) {
						return $q.reject();
					}
					return servicesRestangular.one(id).remove().then(function done(resp) {
						return resp;
					}).catch(function (err) {
						return $q.reject(err);
					});
				};

				return {
					get: get,
					add: add,
					update: update,
					remove: remove
				}
			}
		);
})();

(function() {
    'use strict';

    angular.module('horses.shared')
        .factory('scheduleService',
            function($q, Restangular, $filter) {

                var scheduleRestangular = Restangular.one('schedule');

                var set = function(date, data) {
                    if (!data) {
                        return $q.reject();
                    }
                    return scheduleRestangular.one(formatDate(date)).customPOST({ data: data }).then(function(resp) {
                        return resp.plain();
                    }).catch(function(err) {
                        return $q.reject(err);
                    });
                };

                var load = function(fromDay, toDay) {
                    return scheduleRestangular.one(formatDate(fromDay)).one(toDay ? formatDate(toDay) : formatDate(fromDay))
                        .get({ populate: "guides,horses" })
                        .then(function(resp) {
                            return resp.plain();
                        }).catch(function(err) {
                            return $q.reject(err);
                        });

                };

                var remove = function(date) {
                    if (!date) {
                        return $q.reject();
                    }
                    return scheduleRestangular.one(formatDate(date)).remove().then(function done(resp) {
                        return resp;
                    }).catch(function(err) {
                        return $q.reject(err);
                    });
                };

                var copy = function(date, data) {
                    if (!data) {
                        return $q.reject();
                    }
                    var days = [];
                    angular.forEach(data, function(item) {
                        days.push(formatDate(item));
                    });
                    return scheduleRestangular.one(formatDate(date)).one('copy').customPOST({ data: days });
                };

                function formatDate(item) {
                    return $filter("date")(new Date(item), "MM-dd-y");
                }

                return {
                    set: set,
                    remove: remove,
                    copy: copy,
                    load: load
                }
            }
        );
})();
(function () {
    'use strict';

    angular.module('horses.shared')
        .factory('ordersService',
            function ($q, Restangular, $filter) {

                var restangular = Restangular.one('order');

                var reserve = function (data, date) {
                    if (!data) {
                        return $q.reject();
                    }
                    return restangular.customPOST({data: data, date: date}).then(function (resp) {
                        return resp.plain();
                    }).catch(function (err) {
                        return $q.reject(err);
                    });
                };

                var load = function (data) {

                    if (data.date) data.date = formatDate(data.date);
                    return restangular.get(data).then(function (resp) {
                        return resp.plain();
                    }).catch(function (err) {
                        return $q.reject(err);
                    });

                };

                var cancel = function (id) {
                    return restangular.one(id).customPUT().then(function (resp) {
                        return resp;
                    }).catch(function (err) {
                        return $q.reject(err);
                    });
                };

                var pay = function (id, data) {
                    if (!id || !data) {
                        return $q.reject();
                    }

                    return restangular.one(id).one('pay').customPUT({data: data }).then(function (resp) {
                        if (resp) {
                            return resp.plain();
                        }

                        return {};
                    }).catch(function (err) {
                        return $q.reject(err.data);
                    });
                };

                function formatDate(item) {
                    return $filter("date")(new Date(item), "MM-dd-y");
                }

                return {
                    reserve: reserve,
                    pay: pay,
                    cancel: cancel,
                    load: load
                }
            }
        );
})();

(function () {
  'use strict';

  angular.module('horses.shared')
  .factory('horsesService',
    function ($q,
              Restangular) {

      var horsesRestangular = Restangular.one('horses');

      var get = function (options) {
        options = options || {};
        return horsesRestangular.get(options).then(function (resp) {
          return resp.plain();
        }).catch(function (err) {
          return $q.reject(err);
        });
      };

      var add = function (data) {
        if (!data) {
          return $q.reject();
        }
        return horsesRestangular.customPOST({data: data}).then(function (resp) {
          return resp.plain();
        }).catch(function (err) {
          return $q.reject(err);
        });
      };

      var update = function (id, updatedData) {
        if (!id || !updatedData) {
          return $q.reject();
        }
        return horsesRestangular.one(id).customPUT({data: updatedData}).then(function (resp) {
          return resp.plain();
        }).catch(function (err) {
          return $q.reject(err);
        });
      };

      var remove = function (id) {
        if (!id) {
          return $q.reject();
        }
        return horsesRestangular.one(id).remove().then(function done(resp) {
          return resp;
        }).catch(function (err) {
          return $q.reject(err);
        });
      };

      return {
        get: get,
        add: add,
        update: update,
        remove: remove
      }
    }
  );
})();

(function () {
  'use strict';

  angular.module('horses.shared')
  .factory('guidesService',
    function ($q, Restangular) {

      var guidesRestangular = Restangular.one('guides');

      var get = function (filter, options) {
        options = options || {};

        return guidesRestangular.get(options).then(function (resp) {
          return resp.plain();
        }).catch(function (err) {
          return $q.reject(err);
        });

      };

      var add = function (data) {
        if (!data) {
          return $q.reject();
        }
        return guidesRestangular.customPOST({data: data}).then(function (resp) {
          return resp.plain();
        }).catch(function (err) {
          return $q.reject(err);
        });
      };

      var update = function (id, updatedData) {
        if (!id || !updatedData) {
          return $q.reject();
        }
        return guidesRestangular.one(id).customPUT({data: updatedData}).then(function (resp) {
          return resp.plain();
        }).catch(function (err) {
          return $q.reject(err);
        });
      };

      var remove = function (id) {
        if (!id) {
          return $q.reject();
        }
        return guidesRestangular.one(id).remove().then(function done(resp) {
          return resp;
        }).catch(function (err) {
          return $q.reject(err);
        });
      };

      return {
        get: get,
        add: add,
        update: update,
        remove: remove
      }
    }
  );
})();

(function(angular) {
	'use strict';
	angular.module('facebook-pixel', [])
		.provider('$pixel', function() {
			var $pixelProvider = {
				currency: 'GBP',
				setCurrency: setCurrency,
				setId: setId,
				$get: Pixel
			};
			return $pixelProvider;

			function init() {
				!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
				
				fbq.disablePushState = !!$pixelProvider.disablePushState;
				fbq('init', $pixelProvider.id);
				if (!$pixelProvider.delayPageView) fbq('track', 'PageView');
			}

			function setId(id) {
				$pixelProvider.id = id;
			}

			function setCurrency(currency) {
				$pixelProvider.currency = currency;
			}

			function Pixel() {
				var $pixel = {
					pageView: pageView,
					purchase: purchase,
					addToCart: addToCart,
					track: track
				};
				init();
				return $pixel;

				function pageView() {
					if (!$pixelProvider.id) return;
					fbq('track', 'PageView');
				}

				function purchase(val) {
					if (!$pixelProvider.id) return;
					var params = angular.isObject(val) ? val : {
						value: val
					};
					if (!params.currency) params.currency = $pixelProvider.currency;
					fbq('track', 'Purchase', params);
				}

				function addToCart(val) {
					if (!$pixelProvider.id) return;
					var params = angular.isObject(val) ? val : {
						value: val
					};
					if (!params.currency) params.currency = $pixelProvider.currency;
					fbq('track', 'AddToCart', params);
				}

				function track(event, params) {
					if (!$pixelProvider.id) return;
					fbq('track', event, params);
				}
			}
		});
})(angular);
(function () {
	angular.module('horses.booking')

		.config(function ($stateProvider) {

			$stateProvider
				.state('app.booking', {
					url: 'booking',
					templateUrl: 'app/booking/booking.html',
					controller: 'BookingController',
					controllerAs: 'booking',
					data: {
						authorizedRoles: ['admin', 'manager']
					},
					resolve: {
						services: function(servicesService) {
							return servicesService.get({excluded: "timeslots"});
						}
					}
				});
		});
})();
(function () {
    'use strict';
    angular.module('horses.booking')
        .controller('BookingController',
            function (
                $window, $mdDialog, $document, $pixel,
                ticketsService, services, uuid, RIDERS_BY_ONE_GUIDE, WORKING_DAY_TIME, horsesService, toastr) {
                var self = this;

                $pixel.pageView();

                self.soldout = false;

                self.ticketList = [];

                self.ticketsLoaded = false;

                self.workingTime = WORKING_DAY_TIME;

                var services = services.docs;

                var date = {};
                var orderDate = {};

                (function () {
                    self.myDate = new Date();

                    date = filterDate(self.myDate);
                    orderDate = date;

                    self.minDate = new Date(
                        self.myDate.getFullYear(),
                        self.myDate.getMonth(),
                        self.myDate.getDate()
                    );
                })();

                self.dateChanged = function (date) {
                    orderDate = filterDate(date);
                    renderDay(filterDate(date), services, self.soldout);
                };

                self.persons = [];

                self.newPerson = {
                    name: '',
                    ageCategory: '',
                    weight: '',
                    experience: ''
                };

                function resetNewPerson() {
                    self.newPerson = {
                        name: '',
                        ageCategory: '',
                        weight: '',
                        experience: ''
                    };
                }

                self.applyPersonsFilter = function () {
                    if (self.persons.length) {
                        var services = self.services.slice();

                        var ageMatch, weightMatch, experienceMatch;

                        angular.forEach(services, function (service) {
                            service.allowedPersons = [];

                            angular.forEach(self.persons, function (person) {

                                ageMatch = service.ageCategory.indexOf(person.ageCategory) > -1;
                                weightMatch = service.weight.indexOf(person.weight) > -1;
                                experienceMatch = service.experience.indexOf(person.experience) > -1;

                                if (ageMatch && weightMatch && experienceMatch) {
                                    service.allowedPersons.push(person);
                                    return true;
                                }
                            });

                        });

                        self.services = services;

                        return false;
                    }
                };

                self.addPerson = function (person) {
                    if (validateNewPerson(person)) {
                        self.persons.push(angular.copy(person));
                        resetNewPerson();
                    }
                };

                self.removePerson = function (index) {
                    self.persons.splice(index, 1);
                };

                function validateNewPerson(person) {
                    return person && person.name && person.ageCategory && person.weight && person.experience;
                }

                self.personsFilter = function (service) {
                    if (!self.soldout) {
                        if (self.sharedRides) {
                            return service.allowedPersons && (service.allowedPersons.length === self.persons.length) ? true : false;
                        } else {
                            return (!service.allowedPersons || (service.allowedPersons && service.allowedPersons.length > 0)) ? true : false;
                        }
                    }
                    return service;
                };

                renderDay(date, services);

                self.switchChange = function (date) {
                    if (self.minDate > date && !self.soldout) {
                        renderDay(filterDate(self.minDate), services);
                        self.myDate = self.minDate;
                    } else {
                        renderDay(filterDate(date), services);
                    }
                    self.ticketSoldList = [];
                };

                function renderDay(date, services) {

                    if (self.soldout) {
                        ticketsService.loadReserved(date)
                            .then(function (response) {

                                self.ticketSoldList = [];

                                var ticketsSold = response ? response : [];

                                ticketsSold = _.filter(ticketsSold, function (item) {
                                    return item.order.status === 1 || item.order.status === 3 || item.order.status === 4;
                                });

                                services = associateTickets(services, ticketsSold);

                                services = _.filter(services, function (item) {
                                    return item.ticketsSold.length !== 0;
                                });

                                initServiceColors(services);

                                renderAll(services, ticketsSold);

                            });
                    } else {
                        ticketsService.get(date)
                            .then(function (response) {

                                var tickets = response ? response : [];

                                // associate tickets with services
                                services = associateTickets(services, tickets);

                                services = _.filter(services, function (item) {
                                    return item.tickets.length !== 0;
                                });

                                initServiceColors(services);

                                filterReserved(tickets, ticketList, date, services);

                                renderAll(services, tickets);

                                self.ticketsLoaded = true;

                            });
                    }

                }

                var servicesColors = {};

                function initServiceColors(services) {
                    var colors = [
                        "#ff4500", "#008000", "#7b68ee", "#ff8c00", "#9acd32",
                        "#ff69b4", "#20b2aa", "#808080", "#deb887", "#8b008b"
                    ];

                    servicesColors = {};

                    services.forEach(function (service, index) {
                        servicesColors[service._id] = colors[(index + 1) % 10];
                    });

                }

                self.getColorByServiceId = function (serviceId) {
                    return servicesColors[serviceId];
                };

                self.timeslots = [];

                function associateTickets(services, tickets) {
                    services.forEach(function (service) {
                        service.tickets = [];
                        service.ticketsSold = [];
                        tickets.forEach(function (ticket) {
                            if (ticket.service.id === service._id) {
                                if (self.soldout) {
                                    service.ticketsSold.push(ticket);
                                } else {
                                    service.tickets.push(ticket);
                                }
                            }
                        });
                    });
                    return services;
                }

                function renderAll(services, tickets) {
                    // set min and max timeslot values available
                    var fromTime = WORKING_DAY_TIME.end;
                    var toTime = 0;
                    angular.forEach(tickets, function (ticket) {
                        if (ticket.start < fromTime) fromTime = ticket.start;
                        if (ticket.start > toTime) toTime = ticket.start;
                        ticket.serviceColor = self.getColorByServiceId(ticket.service.id)
                    });

                    // generate available booking timeslots during day
                    var timeslots = [];
                    for (var i = fromTime; i <= toTime; i += WORKING_DAY_TIME.step) {
                        timeslots.push(i);
                    }

                    timeslots = _.orderBy(timeslots);

                    if (self.soldout) {
                        self.timeslotsSold = timeslots;
                    } else {
                        self.timeslots = timeslots;
                    }

                    for (var i = 0; i < services.length; i++) {
                        services[i].serviceColor = self.getColorByServiceId(services[i]._id)
                    }

                    self.services = services;
                }

                var ticketList = [];

                self.addSoldTicket = function (ticket, service) {
                    self.ticketSoldList = [];
                    angular.forEach(service.ticketsSold, function (item) {
                        if (item.service.id === ticket.service.id && item.start === ticket.start) {
                            self.ticketSoldList.push(item);
                        }
                    });
                };

                self.addTicket = function (ticket, service) {
                    var ticketToBook = angular.copy(ticket);
                    ticketToBook.id = uuid.v1();
                    ticketToBook.amount = 1;
                    ticketToBook.serviceName = service.name;
                    ticketToBook.date = filterDate(self.myDate);

                    var guideTotal = (ticket.persons.length - ticket.persons.length % RIDERS_BY_ONE_GUIDE.amount) / RIDERS_BY_ONE_GUIDE.amount + (ticket.persons.length % RIDERS_BY_ONE_GUIDE.amount > 0 ? 1 : 0);
                    // var horsesTotal = service.extraHorse ? ticket.persons.length + guideTotal : ticket.persons.length;

                    var selectedGuides = selectGuides(ticketToBook.guides, ticket.persons.length);
                    var selectedHorses = selectHorses(ticketToBook.horses, guideTotal, ticket.result);

                    var personsCount = ticket.persons.length;

                    angular.forEach(selectedGuides, function (selectedGuide) {
                        while (personsCount > 0 && selectedGuide.reservedBy.length < selectedGuide.maxRiders) {
                            personsCount--;
                            selectedGuide.reservedBy.push(ticketToBook.id);
                        }
                    });

                    angular.forEach(selectedHorses, function (selectedHorse) {
                        selectedHorse.reservedBy = ticketToBook.id;
                    });

                    ticketList.push(ticketToBook);

                    angular.forEach(self.services, function (service) {
                        angular.forEach(service.tickets, function (ticket) {
                            if (((ticket.start >= ticketToBook.start) && (ticket.start < ticketToBook.end)) ||
                                ((ticket.end > ticketToBook.start) && (ticket.end <= ticketToBook.end)) ||
                                ((ticketToBook.start < ticket.end) && (ticketToBook.start >= ticket.start))) {

                                var guideNeed = (service.ridersAmount - service.ridersAmount % RIDERS_BY_ONE_GUIDE.amount) / RIDERS_BY_ONE_GUIDE.amount + (service.ridersAmount % RIDERS_BY_ONE_GUIDE.amount > 0 ? 1 : 0);
                                var horsesNeed = service.extraHorse ? service.ridersAmount + guideNeed : service.ridersAmount;

                                var freeGuides = 0;
                                var freeHorses = 0;
                                var personsCount = ticketToBook.persons.length;

                                if ((ticket.start === ticketToBook.start) && (ticket.end === ticketToBook.end)) {
                                    ticket.service.limit = ticket.service.limit - personsCount;
                                }

                                angular.forEach(ticket.guides, function (guide) {

                                    var index = _.findIndex(selectedGuides, function (selectedGuide) {
                                        return selectedGuide.id === guide.id;
                                    });
                                    if (index !== -1) {
                                        if ((ticket.start === ticketToBook.start) && (ticket.end === ticketToBook.end) && (ticket.service.id === ticketToBook.service.id)) {

                                            while (personsCount > 0 && guide.reservedBy.length < guide.maxRiders) {
                                                personsCount--;
                                                guide.reservedBy.push(ticketToBook.id);
                                            }

                                        } else {
                                            if (guide.reservedBy.length === 0) {
                                                for (var i = 0; i < guide.maxRiders; i++) {
                                                    guide.reservedBy[i] = ticketToBook.id;
                                                }
                                            }
                                        }
                                    }
                                    freeGuides += guide.maxRiders - guide.reservedBy.length;
                                });

                                angular.forEach(ticket.horses, function (horse) {
                                    var index = _.findIndex(selectedHorses, function (selectedHorse) {
                                        return selectedHorse.id === horse.id;
                                    });
                                    if (index !== -1) {
                                        horse.reservedBy = ticketToBook.id;
                                    }
                                    if (horse.reservedBy === null) {
                                        freeHorses++;
                                    }
                                });
                                ((guideNeed <= freeGuides) && (horsesNeed <= freeHorses) && (service.ridersAmount <= ticket.service.limit)) ? ticket.canBeSold = true : ticket.canBeSold = false;
                            }
                        });
                    });
                    var ticketObj = {
                        id: ticketToBook.id,
                        serviceName: ticketToBook.serviceName,
                        start: ticketToBook.start,
                        end: ticketToBook.end,
                        service: {
                            id: ticket.service.id,
                            limit: ticket.service.limit
                        },
                        price: ticketToBook.price,
                        persons: ticketToBook.persons,
                        date: filterDate(self.myDate)
                    };

                    self.ticketList.push(ticketObj);
                    refreshTotalPrice(ticketList);
                };

                self.removeTicket = function (ticketToRemove) {

                    var ticketIndex = _.findIndex(ticketList, function (i) {
                        return i.id === ticketToRemove.id;
                    });
                    ticketToRemove = ticketList[ticketIndex];
                    var notFreeGuides = findNotFreeGuides(ticketToRemove.guides, ticketToRemove.id);
                    var notFreeHorses = findNotFree(ticketToRemove.horses);
                    angular.forEach(self.services, function (service) {
                        angular.forEach(service.tickets, function (ticket) {
                            if (((ticket.start >= ticketToRemove.start) && (ticket.start < ticketToRemove.end)) ||
                                ((ticket.end > ticketToRemove.start) && (ticket.end <= ticketToRemove.end)) ||
                                ((ticketToRemove.start < ticket.end) && (ticketToRemove.start >= ticket.start))) {

                                var guideNeed = (service.ridersAmount - service.ridersAmount % RIDERS_BY_ONE_GUIDE.amount) / RIDERS_BY_ONE_GUIDE.amount + (service.ridersAmount % RIDERS_BY_ONE_GUIDE.amount > 0 ? 1 : 0);
                                var horsesNeed = service.extraHorse ? service.ridersAmount + guideNeed : ticketToRemove.persons.length;

                                var freeGuides = 0;
                                var freeHorses = 0;

                                var personsCount = ticketToRemove.persons.length;

                                if ((ticket.start === ticketToRemove.start) && (ticket.end === ticketToRemove.end)) {
                                    ticket.service.limit = ticket.service.limit + personsCount;
                                }
                                angular.forEach(ticket.guides, function (guide) {

                                    var index = _.findIndex(notFreeGuides, function (i) {
                                        return i.id === guide.id;
                                    });
                                    if (index !== -1) {
                                        if ((ticket.start === ticketToRemove.start) && (ticket.end === ticketToRemove.end) && (ticket.service.id === ticketToRemove.service.id)) {

                                            guide.reservedBy.forEach(function (reserved, index) {
                                                if (reserved === ticketToRemove.id && personsCount > 0) {
                                                    guide.reservedBy[index] = null;
                                                    personsCount--;
                                                }
                                            });
                                            guide.reservedBy = _.remove(guide.reservedBy, null);

                                        } else {
                                            angular.forEach(guide.reservedBy, function (item, index) {
                                                if (item === ticketToRemove.id) {
                                                    guide.reservedBy[index] = null;
                                                }
                                            })
                                            guide.reservedBy = _.remove(guide.reservedBy, null);
                                        }
                                    }

                                    freeGuides += guide.maxRiders - guide.reservedBy.length;

                                });

                                angular.forEach(ticket.horses, function (horse) {
                                    var index = _.findIndex(notFreeHorses, function (i) {
                                        return i.id === horse.id;
                                    });
                                    if (index !== -1) {
                                        horse.reservedBy = null;
                                    }
                                    if (horse.reservedBy === null) {
                                        freeHorses++;
                                    }
                                });
                                ((guideNeed <= freeGuides) && (horsesNeed <= freeHorses) && (service.ridersAmount <= ticket.service.limit)) ? ticket.canBeSold = true : ticket.canBeSold = false;
                            }
                        });
                    });
                    ticketList.splice(ticketIndex, 1);

                    angular.forEach(self.ticketList, function (ticket, index) {
                        if (ticketToRemove.id === ticket.id) {
                            self.ticketList.splice(index, 1);
                        }
                    });

                    refreshTotalPrice(ticketList);
                };

                self.totalPrice = 0;

                var refreshTotalPrice = function (tiketsList) {
                    var price = 0;
                    var allPrice = 0;
                    angular.forEach(tiketsList, function (item) {
                        price = item.price;
                        allPrice += price;
                    });
                    return self.totalPrice = +allPrice.toFixed(12);
                };

                self.pay = function () {
                    var data = [];
                    var isAllTicketsAvalible = true;

                    angular.forEach(ticketList, function (ticket) {
                        if (!ticket.canBeSold) {
                            isAllTicketsAvalible = false;
                        }
                        var guides = [];
                        var horses = [];
                        angular.forEach(ticket.guides, function (item) {
                            var riders = 0;
                            var anotherTicketsRiders = 0;
                            var obj = {};
                            angular.forEach(item.reservedBy, function (i) {
                                if (i == ticket.id) {
                                    riders++;
                                } else if (i && i !== ticket.id) {
                                    anotherTicketsRiders++
                                }
                            });
                            obj.riders = riders;
                            obj.anotherTicketsRiders = anotherTicketsRiders
                            obj.id = item.id;
                            if (obj.riders) {
                                guides.push(obj);
                            }
                        });
                        angular.forEach(ticket.horses, function (item) {
                            if (item.reservedBy !== null) {
                                horses.push(item.id);
                            }
                        });

                        var obj = {
                            id: ticket.id,
                            start: ticket.start,
                            end: ticket.end,
                            service: {
                                id: ticket.service.id,
                                limit: ticket.service.limit
                            },
                            date: ticket.date,
                            guides: guides,
                            horses: horses,
                            persons: ticket.persons,
                            price: ticket.price
                        };
                        data.push(obj);

                    });
                    if (isAllTicketsAvalible) {
                        self.openPaymentDialog(data, orderDate, self.totalPrice);
                    } else {
                        toastr.error('Please, remove unavailable tickets', 'Error');
                    }
                };

                self.openBookingDialog = function (ticket, date, persons, allowedPersons, serviceColor) {
                    $mdDialog.show({
                        controller: "BookingDialog",
                        controllerAs: "bookingDialog",
                        templateUrl: "app/booking/booking-dialog/booking-dialog.template.html",
                        parent: angular.element($document.body),
                        locals: {
                            ticket: ticket,
                            date: date,
                            persons: persons,
                            allowedPersons: allowedPersons,
                            serviceColor: serviceColor,
                            services: services,
                            horses: horsesService.get({}).then(function (resp) { return resp.docs })
                        }
                    })
                        .then(function (ticketToAdd) {
                            self.addTicket(ticketToAdd.ticket, ticketToAdd.service);
                        })
                        .catch(function () { });
                };

                self.openPaymentDialog = function (data, date, totalPrice) {
                    $mdDialog.show({
                        controller: "PaymentDialog",
                        controllerAs: "paymentDialog",
                        templateUrl: "app/booking/payment-dialog/payment-dialog.template.html",
                        parent: angular.element($document.body),
                        locals: {
                            date: date,
                            data: data,
                            totalPrice: totalPrice
                        }
                    }).then(function (data) {
                        if (data && data.status == 'unavailable') {
                            markTicketsToRemove(data.unavalibleTickets);
                            renderDay(filterDate(self.myDate), services);
                        } else {
                            self.ticketList = [];
                            ticketList = [];
                            renderDay(filterDate(self.myDate), services);
                        }
                    }).catch(function () {

                    });
                };

                function markTicketsToRemove(ticketsToRemove) {
                    angular.forEach(ticketsToRemove, function (ticketToRemove) {
                        angular.forEach(self.ticketList, function (ticket, index) {
                            if (ticketToRemove.id === ticket.id) {
                                self.ticketList[index].toRemove = true;
                            }
                        });
                        angular.forEach(ticketList, function (ticket, index) {
                            if (ticketToRemove.id === ticket.id) {
                                ticketList[index].canBeSold = false;
                                ticketList[index].persons = [];
                                angular.forEach(ticketList[index].horses, function (horse) {
                                    horse.reservedBy = null;
                                });
                                angular.forEach(ticketList[index].guides, function (guide) {
                                    guide.reservedBy = [];
                                })
                            }
                        });
                    });
                }

                function selectHorses(horses, guidesCount, orderItems) {
                    // here we select, if needed, a horse for a guide
                    var selectedHorses = [];
                    angular.forEach(horses, function (horse) {

                        var isInOrderItems = _.some(orderItems, function (orderItem) {
                            return orderItem.horse === horse.id;
                        });

                        angular.forEach(orderItems, function (orderItem) {
                            if (orderItem.horse === horse.id) {
                                selectedHorses.push(horse);
                            }
                        });

                        if (horse.reservedBy === null && !isInOrderItems && horseIsSutableForGuide(horse) && guidesCount > 0) {
                            console.info('horse for a guide', horse)
                            selectedHorses.push(horse);
                            guidesCount--;
                        }
                    });

                    return selectedHorses;
                }

                function horseIsSutableForGuide(horse) {
                    return ($window._.includes(horse.data.ageCategory, '>16') 
                        && ($window._.includes(horse.data.weight, '11-12') 
                            || $window._.includes(horse.data.weight, '13-15') 
                            || $window._.includes(horse.data.weight, '16-17') ));
                }

                function selectGuides(guides, personsCount) {
                    var sortedGuides = _.sortBy(guides, ['priority', 'hasPriorityOtherService', 'numberOfServices']);
                    sortedGuides = _.sortBy(sortedGuides, function (guide) {
                        return guide.maxRiders - guide.reservedBy.length;
                    })
                    var freeGuides = [];
                    angular.forEach(sortedGuides, function (guide) {
                        var reservedByLength = guide.reservedBy.length;
                        while (personsCount > 0 && reservedByLength < guide.maxRiders) {
                            personsCount--;
                            reservedByLength++;
                            freeGuides.push(guide);
                        }
                    });
                    return _.uniq(_.sortBy(freeGuides, ['priority', 'hasPriorityOtherService', 'numberOfServices']));
                }

                function findNotFree(resources) {
                    var items = [];
                    angular.forEach(resources, function (i) {
                        if (i.reservedBy !== null) {
                            items.push(i);
                        }
                    });
                    return items;
                }

                function findNotFreeGuides(resources, id) {
                    var items = [];
                    angular.forEach(resources, function (item) {
                        angular.forEach(item.reservedBy, function (i) {
                            if (i === id) {
                                items.push(item);
                            }
                        });
                    });
                    return _.uniq(items);
                }

                function getServiceById(serviceId, services) {
                    return services.find(function (service) {
                        return service._id === serviceId;
                    });
                }

                function filterDate(date) {
                    return $window.moment(date).format("MM-DD-YYYY");
                }

                function filterReserved(tickets, ticketsNA, date, services) {
                    for (var i = 0; i < ticketsNA.length; i++) {
                        if (filterDate(ticketsNA[i].date) === date) {
                            var notFreeGuides = findNotFreeGuides(ticketsNA[i].guides, ticketsNA[i].id);
                            var notFreeHorses = findNotFree(ticketsNA[i].horses);
                            tickets.forEach(function (ticket) {
                                if (((ticket.start >= ticketsNA[i].start) && (ticket.start < ticketsNA[i].end)) ||
                                    ((ticket.end > ticketsNA[i].start) && (ticket.end <= ticketsNA[i].end)) ||
                                    ((ticketsNA[i].start < ticket.end) && (ticketsNA[i].start >= ticket.start))) {

                                    var service = services.find(function (item) {
                                        return item._id == ticket.service.id;
                                    });
                                    var guideNeed = (service.ridersAmount - service.ridersAmount % RIDERS_BY_ONE_GUIDE.amount) / RIDERS_BY_ONE_GUIDE.amount + (service.ridersAmount % RIDERS_BY_ONE_GUIDE.amount > 0 ? 1 : 0);
                                    var horsesNeed = service.extraHorse ? service.ridersAmount + guideNeed : service.ridersAmount;

                                    var freeGuides = 0;
                                    var freeHorses = 0;
                                    var personsCount = ticketsNA[i].persons.length;

                                    if ((ticket.start === ticketsNA[i].start) && (ticket.end === ticketsNA[i].end)) {
                                        ticket.service.limit = ticket.service.limit - personsCount;
                                    }

                                    angular.forEach(ticket.guides, function (guide) {

                                        var index = _.findIndex(notFreeGuides, function (i) {
                                            return i.id === guide.id;
                                        });
                                        if (index !== -1) {
                                            if ((ticket.start === ticketsNA[i].start) && (ticket.end === ticketsNA[i].end) && (ticket.service.id === ticketsNA[i].service.id)) {
                                                while (personsCount > 0 && guide.reservedBy.length < guide.maxRiders) {
                                                    personsCount--;
                                                    guide.reservedBy.push(ticketsNA[i].id);
                                                }
                                            }
                                        }

                                        freeGuides += guide.maxRiders - guide.reservedBy.length;
                                    });

                                    angular.forEach(ticket.horses, function (horse) {
                                        var index = _.findIndex(notFreeHorses, function (i) {
                                            return i.id === horse.id;
                                        });
                                        if (index !== -1) {
                                            horse.reservedBy = ticketsNA[i].id;
                                        }
                                        if (horse.reservedBy === null) {
                                            freeHorses++;
                                        }
                                    });

                                    ((guideNeed <= freeGuides) && (horsesNeed <= freeHorses) && (service.ridersAmount <= ticket.service.limit)) ? ticket.canBeSold = true : ticket.canBeSold = false;
                                }
                            });
                        }
                    }
                }

            });
})();
'use strict';

angular.module('horses.base')

  .config(
    function ($stateProvider) {

      $stateProvider
        .state('app', {
          url: '/',
          templateUrl: 'app/base/base.html',
          controller: 'BaseController',
          controllerAs: 'base'
        });

    });

(function () {
	'use strict';

	angular.module('horses.base')

		.controller('BaseController', function ($mdSidenav, $document, $mdDialog, toastr, userService) {

			var base = this;

			base.getUser = function () {
				userService.get().then(function (data) {
					base.user = data;
				});
			};

			base.getUser();

			base.openDialog = function () {
				$mdDialog.show({
					controller: 'ProfileDialog',
					controllerAs: 'profileDialog',
					templateUrl: 'app/base/profile-dialog/profile-dialog.template.html',
					parent: angular.element($document.body),
					clickOutsideToClose: true,
					locals: {
						user: base.user
					}
				})
					.then(function () {
						toastr.success('Profile is updated!', 'Success');
						return base.getUser();
					});
			};

			base.toggleLeft = function () {
				return $mdSidenav('left').open();
			};

			base.logout = function () {
				var confirm = $mdDialog.confirm()
					.title('Would you like to logout?')
					.ok('Yes')
					.cancel('No');

				$mdDialog.show(confirm).then(function () {
					userService.logout();
				});
			};

            base.isRole = userService.isRole;

			base.menu = [
				{
					title: 'Dashboard',
					state: 'app.dashboard',
					authorizedRoles: ['admin']
				},
				{
					title: 'Manage Services',
					state: 'app.services',
					authorizedRoles: ['admin']
				},
				{
					title: 'Manage Guides',
					state: 'app.guides',
					authorizedRoles: ['admin']
				},
				{
					title: 'Manage Horses',
					state: 'app.horses',
					authorizedRoles: ['admin']
				},
				{
                    title: 'Manage Orders',
                    state: 'app.orders',
                    authorizedRoles: ['admin']
                },
				{
					title: 'Manage Availability',
					state: 'app.availability',
					authorizedRoles: ['admin']
				},
				{
					title: 'Booking',
					state: 'app.booking',
					authorizedRoles: ['admin', 'manager']
				},
				{
					title: 'Validate Ticket',
					state: 'app.validation',
					authorizedRoles: ['admin']
				}
			];

		});
})();

(function () {
  angular.module('horses.availability')

    .config(function ($stateProvider) {

      $stateProvider
        .state('app.availability', {
          url: 'availability',
          templateUrl: 'app/availability/availability.html',
          controller: 'AvailabilityController',
          controllerAs: 'availability',
          data: {
            authorizedRoles: ['admin']
          }
        });
    });
})();
(function() {
    angular.module('horses.availability')

    .controller('AvailabilityController',
        function($document, $mdDialog, $window, $log, toastr, scheduleService, guidesService, horsesService, servicesService, ticketsService) {
            var self = this;

            self.events = [];
            self.schedule = [];
            self.selectedDate = new Date();
            self.firstDayOfWeek = 1;
            var startDay;
            var endDay;

            self.reloadEvents = function(days) {
                startDay = days[0];
                endDay = days[days.length - 1];
                load();
            };

            var load = function() {
                return scheduleService.load(startDay, endDay).then(function(schedule) {
                    self.schedule = schedule;
                    return renderSchedule(schedule);
                });
            };

            var renderSchedule = function(schedule) {
                var events = [];
                angular.forEach(schedule, function(item) {
                    events.push({
                        date: new Date(item.date),
                        html: generateDayContent(item)
                    });
                });
                self.events = events;
            };

            function generateDayContent(scheduleItem) {
                return (scheduleItem.guides.length || scheduleItem.horses.length) ?
                    '<div class="tag items-tag yellow">' +
                    '<div class="items-count">' + scheduleItem.guides.length + '</div>' +
                    '<div class="items-title">Guides</div>' +
                    '</div>' +
                    '<div class="tag items-tag orange">' +
                    '<div class="items-count">' + scheduleItem.horses.length + '</div>' +
                    '<div class="items-title">Horses</div>' +
                    '</div>' :
                    '<p></p>';
            }

            self.dayClick = function(date) {
                openDialog(date);
            };

            function openDialog(date) {
                $mdDialog.show({
                        controller: 'AvailabilityDialog',
                        controllerAs: 'availabilityDialog',
                        templateUrl: 'app/availability/availability-dialog/availability-dialog.template.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose: true,
                        locals: {
                            date: date,
                        },
                        resolve: {
                            data: function(scheduleService) {
                                return scheduleService.load(date).then(function(resp) { return resp });
                            },
                            guides: function(guidesService) {
                                return guidesService.get({}).then(function(resp) { return resp.docs });
                            },
                            horses: function(horsesService) {
                                return horsesService.get({}).then(function(resp) { return resp.docs });
                            },
                            services: function(servicesService) {
                                return servicesService.get({}).then(function(resp) { return resp.docs });
                            },
                            tickets: function(ticketsService) {
                                return ticketsService.loadReserved(formatDate(date)).then(function(resp) { return resp });
                            }
                        }
                    })
                    .then(function(message) {
                        if (message) {
                            toastr.success(message, 'Success');
                        }
                        return load();
                    })
                    .catch(function() {});
            }

            function formatDate(date) {
                return $window.moment(date).format("MM-DD-YYYY");
            }

        });
})();
angular.module("horses.constants", [])
.constant("CANTREF_API_END_POINT", "https://horse-riding-mng.cantref.com/api/v1");

angular.module("horses.constants", [])
.constant("CANTREF_API_END_POINT", "https://horse-riding-mng.cantref.com/api/v1")
.constant("CANTREF_STRIPE_PUBLIC_KEY", "pk_live_LjOTl4KxMpYI9KlvN72TmTxg")
.constant("CANTREF_FB_PIXEL_ID", "343416496294342");

angular.module("horses").run(["$templateCache", function($templateCache) {$templateCache.put("app/availability/availability.html","<div flex class=\"page availability\"><calendar-md reload-events=availability.reloadEvents events=availability.events on-day-click=availability.dayClick title-format=\"\'MMMM y\'\" ng-model=availability.selectedDate week-starts-on=availability.firstDayOfWeek day-format=\"\'d\'\" calendar-direction=availability.direction></calendar-md></div>");
$templateCache.put("app/base/base.html","<div layout=row flex><md-sidenav layout=column md-component-id=left md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-whiteframe=4 class=md-sidenav-left><div layout=row layout-align=\"center center\"><img src=/assets/images/horse-ride.png class=inset></div><md-list><md-list-item ng-repeat=\"item in base.menu\" ui-sref={{item.state}} ng-class=\"{\'active\': $state.is(\'{{item.state}}\')}\" ng-if=base.isRole(item.authorizedRoles)><a>{{item.title}}</a></md-list-item></md-list></md-sidenav><div layout=column flex class=page-wrapper><md-toolbar layout=row layout-align=\"space-between center\"><md-button ng-click=base.toggleLeft() hide-gt-sm class=md-icon-button><md-icon class=material-icons>menu</md-icon></md-button><span flex></span><md-menu><md-button ng-click=$mdOpenMenu($event)><md-icon class=material-icons>person</md-icon>{{ base.user | nameFilter}}<md-icon class=material-icons>more_vert</md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=base.openDialog()><md-icon class=material-icons>person</md-icon>Profile</md-button></md-menu-item><md-menu-item><md-button ng-click=base.logout()><md-icon class=material-icons>exit_to_app</md-icon>Logout</md-button></md-menu-item></md-menu-content></md-menu></md-toolbar><md-content ui-view></md-content></div></div>");
$templateCache.put("app/booking/booking.html","<div layout=row layout-align=center><md-toolbar flex=95 class=toolbar><h3 layout-align=\"center center\" class=md-toolbar-tools>Booking date<md-content layout-padding ng-cloak=\"\"><div layout-gt-xs=row><div flex-gt-xs=\"\"><md-datepicker ng-if=!booking.soldout ng-model=booking.myDate ng-change=booking.dateChanged(booking.myDate) md-min-date=booking.minDate class=datepicker></md-datepicker><md-datepicker ng-if=booking.soldout ng-model=booking.myDate ng-change=booking.dateChanged(booking.myDate) class=datepicker></md-datepicker></div></div></md-content><md-switch ng-model=booking.soldout aria-label=\"Switch 1\" ng-change=booking.switchChange(booking.myDate) class=soldout-switch><span ng-if=!booking.soldout>Available tickets</span><span ng-if=booking.soldout>Sold Out tickets</span></md-switch></h3></md-toolbar></div><div layout=row layout-align=center class=no-animate><div flex=95 class=\"booking no-animate\"><md-content layout=row flex layout-fill><div flex=80 class=schedule><h2 ng-show=!booking.soldout>Please specify users personal details to show only suitable rides<md-checkbox ng-show=\"booking.persons.length &gt; 1\" ng-model=booking.sharedRides class=md-primary>Show only shared rides</md-checkbox></h2><ul ng-if=\"booking.persons.length &gt; 0 &amp;&amp; !booking.soldout\" class=listOfPersons><li ng-repeat=\"person in booking.persons track by $index\"><div layout layout-align=\"space-around center\"><md-input-container><label>Person Name</label><input maxlength=20 ng-model=person.name></md-input-container><md-input-container><label>Age</label><md-select ng-model=person.ageCategory ng-change=booking.applyPersonsFilter()><md-option>4-5</md-option><md-option>6-10</md-option><md-option>11-16</md-option><md-option>&gt;16</md-option></md-select></md-input-container><md-input-container><label>Weight</label><md-select ng-model=person.weight ng-change=booking.applyPersonsFilter()><md-option>&lt;11</md-option><md-option>11-12</md-option><md-option>13-15</md-option><md-option>16-17</md-option></md-select></md-input-container><md-input-container><label>Experience</label><md-select ng-model=person.experience ng-change=booking.applyPersonsFilter()><md-option>beginner</md-option><md-option>novice</md-option><md-option>intermediate</md-option><md-option>experienced</md-option></md-select></md-input-container><md-button ng-click=\"booking.removePerson($index); booking.applyPersonsFilter()\" ng-disabled=\"booking.persons.length &lt; 2\" class=\"md-fab md-mini\"><md-icon class=material-icons>clear</md-icon></md-button></div></li></ul><div ng-if=!booking.soldout class=listOfPersons><form layout layout-align=\"space-around center\" name=personsForm class=newPerson><md-input-container><label class=personName>New Persons Name</label><input ng-model=booking.newPerson.name></md-input-container><md-input-container><label>Age</label><md-select ng-model=booking.newPerson.ageCategory><md-option>4-5</md-option><md-option>6-10</md-option><md-option>11-16</md-option><md-option>&gt;16</md-option></md-select></md-input-container><md-input-container><label>Weight</label><md-select ng-model=booking.newPerson.weight><md-option>&lt;11</md-option><md-option>11-12</md-option><md-option>13-15</md-option><md-option>16-17</md-option></md-select></md-input-container><md-input-container><label>Experience</label><md-select ng-model=booking.newPerson.experience><md-option>beginner</md-option><md-option>novice</md-option><md-option>intermediate</md-option><md-option>experienced</md-option></md-select></md-input-container><md-button ng-click=\"booking.addPerson(booking.newPerson); booking.applyPersonsFilter()\" class=\"md-fab md-primary md-mini\"><md-icon class=material-icons>add</md-icon></md-button></form></div><table class=tickets-table><thead><tr><th ng-if=filteredServices.length></th><th ng-repeat=\"item in booking.services | filter:booking.personsFilter as filteredServices\"><div ng-style=\"{\'color\': item.serviceColor}\" class=servicePrice>&pound;{{item.price}}</div><div class=serviceName>{{item.name}}</div></th></tr><tr ng-show=!booking.soldout class=available><th ng-if=filteredServices.length></th><th ng-repeat=\"item in booking.services | filter:booking.personsFilter\"><div ng-show=item.allowedPersons.length class=availableFor>Available for</div><label ng-repeat=\"allowPerson in item.allowedPersons\" class=allowedPersons>{{ allowPerson.name }}</label></th></tr></thead><tbody><tr ng-if=\"!booking.soldout &amp;&amp; filteredServices.length\" ng-repeat=\"time in booking.timeslots\"><td flex=10 ng-class=\"{notfirst: $first &amp;&amp; time &gt; booking.workingTime.start, notlast: $last &amp;&amp; time &lt; booking.workingTime.end - booking.workingTime.step}\">{{ time | timeFilter }}</td><td ng-repeat=\"service in booking.services | filter:booking.personsFilter track by $index \"><span ng-if=ticket.canBeSold ng-repeat=\"ticket in service.tickets | filter: {start: time, end: time + service.duration} track by $index\" ng-style=\"{\'background-color\': ticket.serviceColor}\" ng-click=\"booking.openBookingDialog(ticket, booking.myDate, booking.persons, service.allowedPersons, ticket.serviceColor)\" class=ticket><span title=\"From {{ticket.start | timeFilter}}. To {{ticket.end | timeFilter}}\" class=ticket-title></span></span></td></tr><tr ng-if=booking.soldout ng-repeat=\"time in booking.timeslotsSold track by $index\"><td flex=10 ng-class=\"{notfirst: $first &amp;&amp; time &gt; booking.workingTime.start, notlast: $last &amp;&amp; time &lt; booking.workingTime.end - booking.workingTime.step}\">{{ time | timeFilter }}</td><td ng-repeat=\"service in booking.services track by $index\"><span ng-repeat=\"ticket in service.ticketsSold | filter: {start: time, end: time + service.duration} track by $index\" ng-style=\"{\'background-color\': ticket.serviceColor}\" ng-click=\"booking.addSoldTicket(ticket, service)\" class=ticket><span title=\"From {{ticket.start | timeFilter}}. To {{ticket.end | timeFilter}}\" class=ticket-title>{{$index + 1}}</span></span></td></tr></tbody></table><h3 ng-if=\"!booking.soldout &amp;&amp; booking.ticketsLoaded &amp;&amp; !booking.timeslots.length\" class=alert>There are no available tickets for this date</h3><h3 ng-if=\"!booking.soldout &amp;&amp; booking.ticketsLoaded &amp;&amp; !filteredServices.length\" class=alert>No matches found! Try to change filter parameters</h3></div><div layout=column flex class=ticket-layout><div layout=column flex layout-align=\"start center\" class=ticket-list><h3 ng-if=booking.soldout>Sold Out tickets info</h3><div ng-if=booking.soldout class=tickets-container><md-card ng-repeat=\"item in booking.ticketSoldList track by $index\"><md-card-content layout=column ng-style=\"{\'background-color\': booking.getColorByServiceId(item.service.id)}\"><div flex><p>Name:<b> {{ item.order.customer.name }}</b></p><p>Phone:<b> {{ item.order.customer.phone }}</b></p><p>Email:<b> {{ item.order.customer.email }}</b></p><p>Riders amount:<b> {{ item.persons.length }}</b></p><p>Status:<b> {{ item.order.status| statusFilter }}</b></p><p>{{ item.start | timeFilter}} - {{ item.end | timeFilter }}</p><span>&pound;{{ item.price | priceFilter }}</span></div></md-card-content></md-card></div><h3 ng-if=!booking.soldout>Book tickets</h3><div ng-if=!booking.soldout class=tickets-container><md-card ng-repeat=\"item in booking.ticketList track by $index\"><md-card-content layout=column ng-style=\"{\'background-color\': booking.getColorByServiceId(item.service.id)}\" ng-class=\"{\'ticket-to-remove\': item.toRemove}\"><div flex><p>{{ item.date }}</p><p>{{ item.serviceName }}</p><p>{{ item.start | timeFilter}} - {{ item.end | timeFilter }}</p><span class=ticket-price>&pound;{{ item.price | priceFilter }}</span><br></div><md-button ng-click=booking.removeTicket(item) class=\"md-fab md-mini\"><md-icon class=material-icons>clear</md-icon></md-button></md-card-content><span ng-if=item.toRemove ng-style=\"{color:\'red\', \'text-align\': \'center\'}\">unavailable</span></md-card></div></div><div ng-if=!booking.soldout layout layout-align=\"space-between center\" class=button-layout><md-button flex ng-click=booking.pay() ng-disabled=!booking.ticketList.length class=\"md-raised md-primary\">Pay &pound;{{ booking.totalPrice | priceFilter }}</md-button></div></div></md-content></div></div>");
$templateCache.put("app/dashboard/dashboard.html","<div flex class=\"page dashboard\"><md-card><md-toolbar><div layout=row class=md-toolbar-tools><md-button ng-click=dashboard.prev() aria-label=\"Previous month\" class=md-icon-button><md-icon md-svg-icon=md-tabs-arrow></md-icon></md-button><div flex=\"\"></div><md-input-container><md-select aria-label=month ng-model=dashboard.month ng-change=dashboard.selectMonth()><md-option ng-repeat=\"month in dashboard.months\" ng-value=month.key>{{month.name}}</md-option></md-select></md-input-container><md-input-container><md-select aria-label=year ng-model=dashboard.year ng-change=dashboard.selectYear()><md-option ng-repeat=\"item in dashboard.years\">{{item}}</md-option></md-select></md-input-container><div flex=\"\"></div><md-button ng-click=dashboard.next() aria-label=\"Next month\" class=md-icon-button><md-icon md-svg-icon=md-tabs-arrow class=moveNext></md-icon></md-button></div></md-toolbar><md-card-content><md-card><md-card-content><div id=widget-ticketsAmount></div></md-card-content></md-card><md-card><md-card-content><div id=widget-ticketsPrice></div></md-card-content></md-card></md-card-content></md-card></div>");
$templateCache.put("app/forgot-password/forgot-password.html","<div layout=row layout-align=center><md-content layout=row layout-align=\"center center\" flex class=forgot-password><md-card flex><md-card-content><div layout=row layout-align=\"center center\" layout-margin class=logo><img src=/assets/images/horse-ride.png></div><div layout=column layout-align=\"center center\"><p>Forgot your password?</p></div><form name=formForgotPwd><md-input-container class=md-block><label>Email</label><md-icon class=material-icons>person</md-icon><input required type=email name=email ng-model=forgotPwd.username ng-pattern=/^.+@.+..+$/ ><div ng-messages=formForgotPwd.email.$error role=alert><div ng-message=required class=my-message>You must supply a email.</div><div ng-message=pattern class=my-message>Email is invalid.</div></div></md-input-container><div layout=row layout-wrap><md-button ng-disabled=!formForgotPwd.$valid ng-click=forgotPwd.forgotPassword() class=\"md-raised md-primary\">Send</md-button></div><span><a ui-sref=login>Back to login</a></span></form></md-card-content></md-card></md-content></div>");
$templateCache.put("app/guides/guides.html","<div flex class=\"page list-guides\"><md-card><md-toolbar><h3 class=md-title>Guides</h3><md-button aria-label=Add ng-click=guides.openDialog() class=\"md-fab md-fab-top-right\"><md-tooltip>Add a guide</md-tooltip><md-icon class=material-icons>add</md-icon></md-button></md-toolbar><md-card-content><md-list><md-list-item layout=row class=list-header><span flex=20>Name</span><span flex=20>Email</span><span flex=20>Phone</span><span flex=35>Address</span></md-list-item><md-divider></md-divider><md-list-item ng-repeat-start=\"row in guides.guides\" layout=row><span flex=20>{{row.firstName}} {{row.lastName}}</span><span flex=20>{{row.email}}</span><span flex=20>{{row.phone}}</span><span flex=35>{{row.address}}</span><div flex=5><md-menu><md-button ng-click=$mdOpenMenu($event) class=md-icon-button><md-icon class=material-icons>more_vert</md-icon></md-button><md-menu-content width=2><md-menu-item><md-button ng-click=guides.openDialog(row)><md-icon class=material-icons>edit</md-icon>Edit</md-button></md-menu-item><md-menu-item><md-button ng-click=guides.remove(row)><md-icon class=material-icons>delete</md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></div></md-list-item><md-list-item ng-repeat-end class=services-list><table><tr><td>Services:</td><td layout=row><span ng-repeat=\"item in row.services\" class=\"tag blue\">{{item.name}}</span></td></tr></table></md-list-item></md-list></md-card-content></md-card></div>");
$templateCache.put("app/horses/horses.html","<div flex class=\"page list-horses\"><md-card><md-toolbar><h3 class=md-title>Horses</h3><md-button aria-label=Add ng-click=horses.openDialog() class=\"md-fab md-fab-top-right\"><md-tooltip>Add a horse</md-tooltip><md-icon class=material-icons>add</md-icon></md-button></md-toolbar><md-card-content><md-list><md-list-item layout=row class=list-header><span flex=20>Name</span><span flex=30>Experience</span><span flex=25>Age Category</span><span flex=20>Weight</span><!--span(flex=\"75\") Services--></md-list-item><md-divider></md-divider><md-list-item ng-repeat=\"row in horses.horses\" layout=row><span flex=20>{{row.name}}</span><span flex=30 layout=column><span ng-repeat=\"item in row.experience\" class=\"tag blue\">{{item}}</span></span><span flex=25 layout=column><span ng-repeat=\"item in row.ageCategory\" class=\"tag purple\">{{item}}</span></span><span flex=20 layout=column><span ng-repeat=\"item in row.weight\" class=\"tag green\">{{item}}</span></span><!--div(flex=\"75\")--><!--  div--><!--    span.tag.purple(ng-repeat=\"item in row.services\") {{item.name}}--><!--      md-tooltip {{item.description}}--><div flex=5><md-menu><md-button ng-click=$mdOpenMenu($event) class=md-icon-button><md-icon class=material-icons>more_vert</md-icon></md-button><md-menu-content width=2><md-menu-item><md-button ng-click=horses.openDialog(row)><md-icon class=material-icons>edit</md-icon>Edit</md-button></md-menu-item><md-menu-item><md-button ng-click=horses.remove(row)><md-icon class=material-icons>delete</md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></div></md-list-item></md-list></md-card-content></md-card></div>");
$templateCache.put("app/login/login.html","<div layout=row layout-align=center><md-content layout=row layout-align=\"center center\" flex class=login><md-card flex><md-card-content><div layout=row layout-align=\"center center\" layout-margin class=logo><img src=/assets/images/horse-ride.png></div><form name=Login ng-submit=login.login()><md-input-container class=md-block><label>Email</label><md-icon class=material-icons>person</md-icon><input required type=email name=email ng-model=login.username minlength=10 maxlength=100 ng-pattern=/^.+@.+..+$/ ><div ng-messages=Login.email.$error role=alert><div ng-message=required class=my-message>You must supply a email.</div><div ng-message=pattern class=my-message>Email is invalid.</div></div></md-input-container><md-input-container class=md-block><label>Password</label><md-icon class=material-icons>lock</md-icon><input type=password name=password ng-model=login.password required><div ng-messages=Login.password.$error role=alert><div ng-message=required class=my-message>You must supply a password.</div></div></md-input-container><div layout=row layout-align=\"space-between start\"><md-checkbox ng-model=login.rememberMe class=md-primary>Remember me</md-checkbox><span><a ui-sref=forgotPassword>Forgot your password?</a></span></div><div layout=row layout-wrap><md-button ng-disabled=!Login.$valid type=submit class=\"md-raised md-primary\">Login</md-button></div></form></md-card-content></md-card></md-content></div>");
$templateCache.put("app/orders/orders.html","<div flex class=\"page list-orders\"><md-card><md-toolbar class=toolbar-orders><h3 layout-align=\"space-between center\" class=md-toolbar-tools><div layout=row layout-align=\"start center\" ng-if=!orders.search><div>Orders for</div><md-datepicker ng-model=orders.date md-placeholder=\"Enter date\" ng-change=orders.getOrdersList(orders.date) class=datepicker></md-datepicker><md-button ng-click=orders.dayReport() class=info-button><md-icon class=material-icons>info_outline</md-icon>Day Report</md-button></div><div ng-if=!orders.search><md-button ng-click=\"orders.search = !orders.search\"><md-icon class=material-icons>search</md-icon>Search</md-button></div><div ng-if=orders.search flex><div layout=row layout-align=\"space-between center\"><md-button ng-click=\"orders.search = !orders.search; orders.getOrdersList(orders.date)\"><md-icon class=material-icons>arrow_back</md-icon>Back</md-button><form ng-submit=orders.searchOrders(orders.searchText) flex><md-input-container class=\"md-block search-order\"><input ng-model=orders.searchText aria-label=\"Search text\"></md-input-container></form><md-button ng-click=orders.searchOrders(orders.searchText)><md-icon class=material-icons>search</md-icon></md-button></div></div></h3></md-toolbar><md-card-content><md-list class=order><h4 class=message-info>💡 Orders made on this day, to see booked rides for this day click \"DAY REPORT\" button above</h4><md-list-item layout=row class=list-header><span flex=15>Name</span><span flex=20>Email</span><span flex=15>Phone</span><span flex=5>Postal</span><span flex=20>Comment</span><span flex=5>Price</span><span flex=5>Tickets</span><span flex=10>Status</span><span flex=5></span></md-list-item><md-divider></md-divider><h3 ng-if=!orders.orders.length class=no-items-text>There are no orders for this date</h3><md-list-item ng-repeat=\"row in orders.orders\" layout=row ng-click=orders.openDialog(row) layout-padding class=\"list-body order-status__{{row.status}}\"><span flex=15>{{row.customer.name}} {{row.lastName}}</span><span flex=20>{{row.customer.email}}</span><span flex=15>{{row.customer.phone}}</span><span flex=5>{{row.customer.postal}}</span><span flex=20 class=order-comment>{{row.customer.comment}}</span><span flex=5>&pound;{{row.totalPrice}}</span><span flex=5>{{row.tickets.length}}</span><span flex=10> <span class=order-status-label>{{row.status | statusFilter}}</span><span ng-if=row.paymentType class=order-payment-type>{{row.paymentType}}</span></span><div flex=5><md-menu><md-button ng-click=$mdOpenMenu($event) class=md-icon-button><md-icon class=material-icons>more_vert</md-icon></md-button><md-menu-content width=2><md-menu-item><md-button ng-click=orders.openDialog(row)><md-icon class=material-icons>zoom_in</md-icon>View</md-button></md-menu-item><md-menu-item><md-button ng-click=orders.cancel(row)><md-icon class=material-icons>block</md-icon>Cancel</md-button></md-menu-item></md-menu-content></md-menu></div></md-list-item></md-list></md-card-content></md-card></div>");
$templateCache.put("app/password-recovery/custom-messages.template.html","<div ng-message=required>Required</div><div ng-message=compareTo>New passwords must be the same</div><div ng-message=minlength>Password is too short</div>");
$templateCache.put("app/password-recovery/password-recovery.html","<div layout=row layout-align=center><md-content layout=row layout-align=\"center center\" flex class=forgot-password><md-card flex><md-card-content><div layout=row layout-align=\"center center\" layout-margin class=logo><img src=/assets/images/horse-ride.png></div><form name=pwdRecoveryForm ng-submit=pwdRecovery.resetPassword()><md-input-container class=md-block><label>New password</label><md-icon class=material-icons>lock</md-icon><input type=password ng-model=pwdRecovery.password.newPass name=newPass minlength=4 required class=form-control><div ng-messages=pwdRecoveryForm.newPass.$error ng-show=pwdRecoveryForm.newPass.$dirty role=alert><div ng-message=required>Required</div><div ng-message=compareTo>New passwords must be the same</div><div ng-message=minlength>Password is too short</div></div></md-input-container><md-input-container class=md-block><label>Retype new password</label><md-icon class=material-icons>lock</md-icon><input type=password ng-model=pwdRecovery.password.confirmPass compare-to=pwdRecovery.password.newPass name=confirmPass minlength=4 required class=form-control><div ng-messages=pwdRecoveryForm.confirmPass.$error ng-show=pwdRecoveryForm.confirmPass.$dirty role=alert><div ng-message=required>Required</div><div ng-message=compareTo>New passwords must be the same</div><div ng-message=minlength>Password is too short</div></div></md-input-container><div layout=row layout-wrap><md-button type=submit ng-disabled=\"pwdRecoveryForm.$invalid || pwdRecovery.pending\" class=\"md-raised md-primary\">Update password</md-button></div></form></md-card-content></md-card></md-content></div>");
$templateCache.put("app/services/services.html","<div flex class=\"page list-services\"><md-card><md-toolbar><h3 class=md-title>Services</h3><md-button aria-label=Add ng-click=services.openDialog() class=\"md-fab md-fab-top-right\"><md-tooltip>Add a service</md-tooltip><md-icon class=material-icons>add</md-icon></md-button></md-toolbar><md-card-content><md-list><md-list-item layout=row class=list-header><span flex=20>Name</span><span flex=30>Description</span><span flex=30>Experience</span><span flex=10>Age Category</span><span flex=10>Weight</span></md-list-item><md-divider></md-divider><md-list-item ng-repeat=\"row in services.services\" layout=row><span flex=20>{{row.name}}</span><span flex=30>{{row.description}}</span><span flex=30 layout=column><span ng-repeat=\"item in row.experience\" class=\"tag blue\">{{item}}</span></span><span flex=10 layout=column><span ng-repeat=\"item in row.ageCategory\" class=\"tag purple\">{{item}}</span></span><span flex=5 layout=column><span ng-repeat=\"item in row.weight\" class=\"tag green\">{{item}}</span></span><div flex=5><md-menu><md-button aria-label=\"Open action menu\" ng-click=$mdOpenMenu($event) class=md-icon-button><md-icon class=material-icons>more_vert</md-icon></md-button><md-menu-content><md-menu-item><md-button aria-label=\"Edit service\" ng-click=services.openDialog(row)><md-icon class=material-icons>edit</md-icon>Edit</md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete service\" ng-click=services.remove(row)><md-icon class=material-icons>delete</md-icon>Delete</md-button></md-menu-item></md-menu-content></md-menu></div></md-list-item></md-list></md-card-content></md-card></div>");
$templateCache.put("app/validate-ticket/validate-ticket.html","<div flex class=\"page validation\"><md-card><md-toolbar><h3 class=md-title>Validate Ticket</h3></md-toolbar><md-card-content><div layout=row layout-align=center class=contentLayout><form name=validateTicketForm ng-submit=validateTicket.checking(validateTicket.ticket.ticketId)><div layout=row layout-align=\"center center\"><md-input-container class=md-block><label>Security code</label><input autofocus ng-model=validateTicket.ticket.ticketId></md-input-container></div><div layout=row layout-align=\"center center\"><md-button type=submit class=\"md-raised md-primary\">Validate</md-button></div></form></div><div layout=row layout-align=center class=contentLayout><div ng-if=validateTicket.ticketReturned flex=70 ng-style=validateTicket.getColorByStatus(validateTicket.ticketReturned.status) class=box><div class=ticket><h2 class=service>{{ validateTicket.ticketReturned.ticket.service.name }}</h2><p ng-if=\"validateTicket.ticketReturned.status !== \'notFound\'\" ng-repeat=\"ticket in validateTicket.ticketReturned.ticket.order.tickets\" class=date>{{ ticket.date }}<span> &#64; {{ validateTicket.ticketReturned.ticket.start | timeFilter }} - {{ validateTicket.ticketReturned.ticket.end | timeFilter }}</span></p><div layout=row ng-if=\"validateTicket.ticketReturned.status !== \'notFound\'\"><div flex=15><p class=dataGroup>Owner:</p></div><div flex><p class=ownerData><label>{{ validateTicket.ticketReturned.ticket.order.customer.name }}</label></p><p class=ownerData>email:<label>{{ validateTicket.ticketReturned.ticket.order.customer.email }}</label></p><p class=ownerData>security code:<label>{{ validateTicket.ticketReturned.ticket.shortId }}</label></p><p class=ownerData>price:<label>&pound;{{ validateTicket.ticketReturned.ticket.order.totalPrice }}</label></p></div></div><div layout=row ng-if=\"validateTicket.ticketReturned.status !== \'notFound\'\"><div flex=15><p class=dataGroup>Riders:</p></div><div flex><ul><li ng-repeat=\"person in validateTicket.ticketReturned.ticket.persons\"><p class=ridersData>name:<label>{{ person.name }},</label></p><p class=ridersData>experience:<label>{{ person.experience }},</label></p><p class=ridersData>weight:<label>{{ person.weight }},</label></p><p class=ridersData>ageCategory:<label>{{ person.ageCategory }}</label></p></li></ul></div></div><h2 class=status>{{ validateTicket.ticketReturned.message }}</h2></div></div></div></md-card-content></md-card></div>");
$templateCache.put("app/availability/availability-dialog/availability-dialog.template.html","<md-dialog aria-label=\"Add schedule\" flex=50 class=schedules-dialog><md-toolbar><div class=md-toolbar-tools><h2>Schedule {{availabilityDialog.date | date:\'MM-dd-yyyy\'}}</h2><span flex=\"\"></span><md-button ng-click=availabilityDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=column class=md-dialog-content><div><h3>Pick services below</h3><!--div(style=\'text-align: right\')\n        md-button.md-raised.md-primary(ng-click=\'availabilityDialog.setPriority()\',\n          ng-disabled=\'availabilityDialog.data.services.length === 0 || availabilityDialog.data.guides.length === 0\')\n          | Set Priority\n        --><div layout=row><span>Services:</span><span flex></span><span style=\"margin-right: 20px\">Limit:</span><span style=\"margin-right: -20px\">Display only<br>in admin:</span></div><md-divider></md-divider><div class=services><div ng-repeat=\"item in availabilityDialog.services\" layout=row layout-align=\"center center\"><md-checkbox ng-click=\"availabilityDialog.toggle(\'services\', item, availabilityDialog.data.services)\" ng-checked=\"availabilityDialog.exists(item, availabilityDialog.data.services)\" ng-disabled=item.disable class=md-primary>{{ item.name }}</md-checkbox><span flex></span><md-input-container><label></label><input ng-model=item.limit type=number ng-change=\"availabilityDialog.amountChange(item, availabilityDialog.data.services)\" min=0><span flex></span></md-input-container><md-checkbox aria-label=\" \" ng-click=\"availabilityDialog.setAvailibleInAdminOnly(item, availabilityDialog.data.services)\" ng-checked=\"availabilityDialog.availibleInAdminOnly(item, availabilityDialog.data.services)\" class=md-primary></md-checkbox></div></div><md-divider></md-divider></div><div><h3>Pick guides below</h3><div>Guides:</div><md-divider></md-divider><div class=\"services guide-change\"><div ng-repeat=\"guide in availabilityDialog.guides\"><md-checkbox ng-click=\"availabilityDialog.toggle(\'guides\', guide, availabilityDialog.data.guides)\" ng-checked=\"availabilityDialog.exists(guide, availabilityDialog.data.guides)\" class=md-primary>{{ guide.firstName }} {{ guide.lastName }}</md-checkbox></div></div><md-divider></md-divider></div><div><h3>Pick horses below</h3><div>Horses:</div><md-divider></md-divider><div class=\"services horse-change\"><div ng-repeat=\"horse in availabilityDialog.horses\"><md-checkbox ng-click=\"availabilityDialog.toggle(\'horses\', horse, availabilityDialog.data.horses)\" ng-checked=\"availabilityDialog.exists(horse, availabilityDialog.data.horses)\" class=md-primary>{{ horse.name }}</md-checkbox></div></div><md-divider></md-divider></div></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between center\"><div><md-button ng-click=availabilityDialog.deleteFromSchedule() ng-disabled=\"availabilityDialog.create || availabilityDialog.disabled\" class=\"md-raised md-warn\"><md-icon class=material-icons>delete</md-icon>Delete</md-button><md-button ng-click=availabilityDialog.copyScheduleFromDay() ng-disabled=\"availabilityDialog.create || availabilityDialog.disabled\" class=md-raised><md-icon class=material-icons>content_copy</md-icon>Copy</md-button></div><div><md-button ng-click=availabilityDialog.addToSchedule() ng-disabled=availabilityDialog.disabled class=\"md-raised md-primary\">Save</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/availability/change-guide-dialog/change-guide-dialog.template.html","<md-dialog aria-label=\"Change Guide\" flex=40 class=change-guide-dialog><md-toolbar><div class=md-toolbar-tools><h2>Change guide</h2><span flex=\"\"></span><md-button ng-click=changeGuideDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding=\"\" class=md-dialog-content><span ng-if=!changeGuideDialog.isAnyAvailableGuide>There are no available guides to change selected</span><span ng-if=changeGuideDialog.isAnyAvailableGuide>Please, select guide from list below</span><md-radio-group ng-model=changeGuideDialog.selectedGuide><div ng-repeat=\"guide in changeGuideDialog.availableGuides\" class=row><div flex layout=row layout-align=\"start center\" ng-click=changeGuideDialog.select()><md-radio-button flex ng-value=guide class=\"new-guide md-primary\">{{guide.firstName}} {{guide.lastName}}</md-radio-button></div></div></md-radio-group></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button ng-if=changeGuideDialog.isAnyAvailableGuide ng-click=changeGuideDialog.updateTickets() ng-disabled=changeGuideDialog.disabled class=\"md-raised md-primary\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/availability/change-horse-dialog/change-horse-dialog.template.html","<md-dialog aria-label=\"Change Horse\" flex=40 class=change-horse-dialog><md-toolbar><div class=md-toolbar-tools><h2>Change horse</h2><span flex=\"\"></span><md-button ng-click=changeHorseDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding=\"\" class=md-dialog-content><span ng-if=!changeHorseDialog.isAnyAvailableHorse>There are no available horses to change selected</span><span ng-if=changeHorseDialog.isAnyAvailableHorse>Please, select horse from list below</span><md-radio-group ng-model=changeHorseDialog.selectedHorse><div ng-repeat=\"horse in changeHorseDialog.availableHorses\" class=row><div flex layout=row layout-align=\"start center\" ng-click=changeHorseDialog.select()><md-radio-button flex ng-value=horse class=\"new-horse md-primary\">{{horse.name}}</md-radio-button></div></div></md-radio-group></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button ng-if=changeHorseDialog.isAnyAvailableHorse ng-click=changeHorseDialog.updateTickets() ng-disabled=changeHorseDialog.disabled class=\"md-raised md-primary\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/availability/copy-dialog/copy-dialog.template.html","<md-dialog aria-label=\"Copy schedule\" flex=50><md-toolbar><div class=md-toolbar-tools><h2>Copy schedule from {{copyDialog.date | date:\'MM-dd-yyyy\'}}</h2><span flex=\"\"></span><md-button ng-click=copyDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column layout-padding=\"\" class=copy-day><p>Select the day(s) for which you want to copy the schedule.</p><calendar-md flex=\"\" layout=\"\" layout-fill=\"\" reload-events=copyDialog.reloadEvents on-prev-month=copyDialog.prevMonth on-next-month=copyDialog.nextMonth on-day-click=copyDialog.dayClick title-format=\"\'MMMM y\'\" ng-model=copyDialog.selectedDate week-starts-on=copyDialog.firstDayOfWeek day-format=\"\'d\'\" without-content=copyDialog.withoutContent></calendar-md></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button ng-click=copyDialog.copyToSchedule() ng-disabled=copyDialog.disabled class=\"md-raised md-primary\">Copy</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/availability/set-priority/set-priority.template.html","<md-dialog aria-label=\"Set priority\" flex=80 class=set-priority><md-toolbar><div class=md-toolbar-tools><h2>Set priority</h2><span flex=\"\"></span><md-button ng-click=setPriority.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></div></md-toolbar><md-dialog-content layout=column class=md-dialog-content><table><thead><tr><th class=first-column>Services</th><th ng-repeat=\"item in setPriority.guides\" class=column>{{item.firstName}} {{item.lastName}}</th></tr></thead><tbody><tr ng-repeat=\"(rowIndex, service) in setPriority.services\"><td class=first-column>{{service.data.name}}</td><td ng-repeat=\"guide in setPriority.guides\" class=column><md-input-container><md-select required ng-model=service.guidesPriority[$index].priority ng-change=\"setPriority.setPriority(rowIndex, $index, guide._id)\" placeholder=\" \"><md-option ng-repeat=\"priority in service.data.priorityValues\" ng-value=priority.value ng-disabled=\"priority.isSelected &amp;&amp; priority.value !== 0\">{{priority.displayValue}}</md-option></md-select></md-input-container></td></tr></tbody><md-divider></md-divider></table></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button ng-click=setPriority.savePriorities() ng-disabled=copyDialog.disabled class=\"md-raised md-primary\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/base/profile-dialog/profile-dialog.template.html","<md-dialog aria-label=\"Add horses\" flex=30><form name=Profile><md-toolbar><div class=md-toolbar-tools><h2>Edit profile</h2><span flex=\"\"></span><md-button ng-click=profileDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-input-container class=md-block><label>First Name</label><input type=text name=firstName ng-model=profileDialog.data.firstName></md-input-container><md-input-container class=md-block><label>Last Name</label><input type=text name=lastName ng-model=profileDialog.data.lastName></md-input-container><md-input-container class=md-block><label>Email</label><input ng-model=profileDialog.data.email required type=email name=email ng-pattern=/^.+@.+..+$/ autocomplete=new-email><div ng-messages=Profile.email.$error role=alert><div ng-message=required class=my-message>You must supply a email.</div><div ng-message=pattern class=my-message>Email is invalid.</div></div></md-input-container><md-input-container class=md-block><label>Password</label><input type=password name=newPassword ng-minlength=6 ng-model=profileDialog.data.newPassword autocomplete=new-password><div ng-messages=Profile.newPassword.$error role=alert><div ng-message=minlength class=my-message>Password is too short.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-disabled=!Profile.$valid ng-click=profileDialog.save() class=\"md-raised md-primary\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/booking/booking-dialog/booking-dialog.template.html","<md-dialog aria-label=Booking flex=60 class=booking-dialog><md-toolbar class=md-toolbar-tools><h2>Booking details</h2><span flex=\"\"></span><md-button ng-click=bookingDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></md-toolbar><md-dialog-content class=md-dialog-content><div layout=row layout-align=\"space-around center\"><div flex=70><span ng-style=\"{\'background-color\': bookingDialog.serviceColor}\" class=ticket><span class=ticket-title>{{ bookingDialog.service.name }}</span></span><span ng-style=\"{\'color\': bookingDialog.serviceColor}\" class=ticket-price>&pound;{{ bookingDialog.service.price }} * {{ bookingDialog.countRiders }} = &pound;{{ bookingDialog.service.price * bookingDialog.countRiders}}</span></div><div flex><p class=bookingDate>{{ bookingDialog.date }}</p><p class=bookingTime>{{ bookingDialog.ticket.start | timeFilter }} - {{ bookingDialog.ticket.end | timeFilter }}</p></div></div><h4>Please enter at least {{ bookingDialog.service.ridersAmount }} persons for this ticket</h4><h4 ng-if=\"bookingDialog.confirmPersonsDisable(bookingDialog.personsList.length - 1)\" class=accent>Number of riders more than allowed. Please remove a few.</h4><form novalidate layout=column layout-align=\"center center\" name=personsDialogForm id=personsform ng-submit=\"personsDialogForm.$valid &amp;&amp; bookingDialog.confirm(bookingDialog.ticket, bookingDialog.service, bookingDialog.personsList)\" class=personsForm><div ng-repeat=\"person in bookingDialog.personsList\" ng-class=\"person.unsuitable ? \'unsuitable\' : \'\'\"><md-input-container><label>New Persons Name</label><input required ng-model=person.name></md-input-container><md-input-container><label>Age</label><md-select required ng-model=person.ageCategory ng-change=bookingDialog.change(person)><md-option ng-repeat=\"age in bookingDialog.service.ageCategory\">{{ age }}</md-option></md-select></md-input-container><md-input-container><label>Weight</label><md-select required ng-model=person.weight ng-change=bookingDialog.change(person)><md-option ng-repeat=\"weight in bookingDialog.service.weight\">{{ weight }}</md-option></md-select></md-input-container><md-input-container><label>Experience</label><md-select required ng-model=person.experience ng-change=bookingDialog.change(person)><md-option ng-repeat=\"exp in bookingDialog.service.experience\">{{ exp }}</md-option></md-select></md-input-container><md-button ng-click=bookingDialog.removePerson($index) ng-disabled=\"bookingDialog.personsList.length &lt;= bookingDialog.service.ridersAmount\" class=\"md-fab md-mini\"><md-icon class=material-icons>clear</md-icon></md-button><div layout=row layout-align=\"center center\" ng-if=person.unsuitable class=err>Sorry, can\'t provide this rider.</div></div></form><md-dialog-actions layout=row><md-button ng-click=bookingDialog.addPersonToList(bookingDialog.personsList) ng-disabled=bookingDialog.confirmPersonsDisable(bookingDialog.personsList.length) class=\"md-raised md-accent\">Add person</md-button><md-button type=submit form=personsform ng-disabled=\"personsDialogForm.$invalid || !bookingDialog.personsList.length || bookingDialog.countRiders &lt; bookingDialog.service.ridersAmount || bookingDialog.confirmPersonsDisable(bookingDialog.personsList.length - 1)\" class=\"md-raised md-primary\">Book a ticket</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/booking/payment-dialog/payment-dialog.template.html","<md-dialog aria-label=Booking flex=50 class=payment-dialog><md-toolbar class=md-toolbar-tools><h2>Payment details</h2><span flex=\"\"></span><md-button ng-click=paymentDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></md-toolbar><md-dialog-content class=md-dialog-content><md-stepper-card-content class=md-no-padding><md-steppers md-dynamic-height=\"\" md-disable-tabs-behavior=true md-stretch-steppers=always md-selected=paymentDialog.selectedStep md-busy-text=\"\'Processing...\'\" md-busy=paymentDialog.showBusyText><md-step label=\"Personal details\" md-complete=paymentDialog.stepData[0].data.completed ng-disabled=\"paymentDialog.stepProgress &lt; 1\"><md-step-body><form name=step1 ng-submit=paymentDialog.submitCurrentStep(paymentDialog.stepData[0].data)><md-content class=md-padding><div layout=row layout-align=\"center top\"><div flex=nogrow style=\"width: 400px\"><h4>Please enter your personal details</h4><md-input-container class=md-block><label>Name</label><input ng-disabled=paymentDialog.stepData[0].data.completed ng-model=paymentDialog.personalDetails.name required></md-input-container><md-input-container class=md-block><label>Phone number</label><input ng-disabled=paymentDialog.stepData[0].data.completed type=text ng-model=paymentDialog.personalDetails.phone required></md-input-container><md-input-container class=md-block><label>Email</label><input ng-disabled=paymentDialog.stepData[0].data.completed type=email ng-model=paymentDialog.personalDetails.email required></md-input-container><md-input-container class=md-block><label>Postal code</label><input ng-disabled=paymentDialog.stepData[0].data.completed type=postal ng-model=paymentDialog.personalDetails.postal required></md-input-container><md-input-container class=md-block><label>Comments</label><textarea ng-disabled=paymentDialog.stepData[0].data.completed md-maxlength=150 rows=3 ng-model=paymentDialog.personalDetails.comment></textarea></md-input-container></div></div></md-content><md-step-actions layout=row><div flex=\"\" layout=row layout-align=\"end top\"><md-button type=submit ng-disabled=step1.$invalid class=\"md-primary md-raised\">NEXT</md-button></div></md-step-actions></form></md-step-body></md-step><md-step label=\"Payment details\" md-complete=paymentDialog.stepData[1].data.completed ng-disabled=\"paymentDialog.stepProgress &lt; 2\"><md-step-body><md-content><div layout=row layout-align=\"center top\"><div flex=nogrow style=\"width: 400px\"><h4>Choose a payment method</h4><md-radio-group ng-model=paymentDialog.payment><md-radio-button value=card>Pay by card</md-radio-button><div layout=row layout-align=\"space-between center\"><form name=step2 class=card-element><label><div id=card-element class=\"field is-empty\"></div><span><span>Card</span></span></label></form></div><md-radio-button value=cash>Pay by cash</md-radio-button></md-radio-group></div></div><md-step-actions layout=row><div flex=\"\" layout=row layout-align=\"end top\"><md-button type=submit ng-disabled=\"\" ng-click=paymentDialog.charge() class=\"md-primary md-raised\">Pay</md-button></div></md-step-actions></md-content></md-step-body></md-step></md-steppers></md-stepper-card-content></md-dialog-content></md-dialog>");
$templateCache.put("app/components/calendar/angular-material-calendar.html","<md-content layout=column layout-fill=\"\" md-swipe-left=next() md-swipe-right=prev()><md-toolbar><div layout=row class=md-toolbar-tools><md-button ng-click=prev() aria-label=\"Previous month\" class=md-icon-button><md-tooltip ng-if=::tooltips()>Previous month</md-tooltip><md-icon md-svg-icon=md-tabs-arrow></md-icon></md-button><div flex=\"\"></div><md-input-container><md-select ng-if=months aria-label=month ng-model=calendar.month ng-change=selectMonth()><md-option ng-repeat=\"month in months\" ng-value=month.key>{{month.name}}</md-option></md-select></md-input-container><md-input-container><md-select ng-if=years aria-label=year ng-model=calendar.year ng-change=selectYear()><md-option ng-repeat=\"item in years\">{{item}}</md-option></md-select></md-input-container><div flex=\"\"></div><md-button ng-click=next() aria-label=\"Next month\" class=md-icon-button><md-tooltip ng-if=::tooltips()>Next month</md-tooltip><md-icon md-svg-icon=md-tabs-arrow class=moveNext></md-icon></md-button></div></md-toolbar><md-content ng-if=\"weekLayout !== columnWeekLayout\" flex=\"\" layout=column class=calendar><div layout=row class=subheader><div layout-padding=\"\" flex=\"\" ng-repeat=\"day in calendar.weeks[0]\" class=subheader-day><md-tooltip ng-if=::tooltips()>{{ day | date:dayLabelTooltipFormat }}</md-tooltip>{{ day | date:dayLabelFormat }}</div></div><div ng-if=week.length ng-repeat=\"week in calendar.weeks track by $index\" flex=\"\" layout=row><div tabindex=\"{{ sameMonth(day) ? (day | date:dayFormat:timezone) : 0 }}\" ng-repeat=\"day in week track by $index\" ng-click=handleDayClick(day) flex=\"\" layout=\"\" ng-class=\"{&quot;active&quot;: isActive(day), &quot;has-events&quot;: hasEvents(day)}\" ng-focus=\"focus = true;\" ng-blur=\"focus = false;\" ng-mouseleave=\"hover = false\" ng-mouseenter=\"hover = true\" class=md-calendar-day-box><div flex=\"\" layout=column ng-class=\"{&quot;md-whiteframe-12dp&quot;: hover || focus}\" class=calendar-day-inner><div class=calendar-day>{{ day | date:dayFormat }}</div><div ng-bind-html=dataService.data[dayKey(day)] class=calendar-content></div></div><div layout=column ng-if=\"dataService.data[dayKey(day)] !== \'&lt;p&gt;&lt;/p&gt;\'\"></div></div></div></md-content></md-content>");
$templateCache.put("app/components/loadingSpinner/loadingSpinner.html","<div ng-if=spinnerActive class=spinnerShowbox><div class=spinnerBackground-blur></div><div class=spinnerLoader><md-progress-circular md-diameter=90></md-progress-circular></div></div>");
$templateCache.put("app/components/time/time.html","<div>{{h}}<sup>{{m}}</sup></div>");
$templateCache.put("app/guides/guide-dialog/guide-dialog.template.html","<md-dialog aria-label=guide flex=30 class=guide-dialog><form name=Guide><md-toolbar><div class=md-toolbar-tools><h2>{{ guidesDialog.isNew ? \'Add a guide\' : \'Update the guide\' }}</h2><span flex=\"\"></span><md-button ng-click=guidesDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-input-container class=md-block><label>First name</label><input type=text name=name required ng-model=guidesDialog.data.firstName></md-input-container><md-input-container class=md-block><label>Last name</label><input type=text name=surname required ng-model=guidesDialog.data.lastName></md-input-container><md-input-container class=md-block><label>Email</label><input type=email name=email ng-model=guidesDialog.data.email required ng-pattern=/^.+@.+..+$/ ><div ng-messages=Guide.email.$error role=alert><div ng-message=required class=my-message>Email is required.</div><div ng-message=pattern class=my-message>Email is invalid.</div></div></md-input-container><md-input-container class=md-block><label>Address</label><input type=text name=address ng-model=guidesDialog.data.address></md-input-container><md-input-container class=md-block><label>Phone</label><input type=text name=number ng-model=guidesDialog.data.phone></md-input-container><div><h3>Pick a service below</h3><div>Services:</div><div isteven-multi-select=\"\" input-model=guidesDialog.services output-model=guidesDialog.data.services button-label=name item-label=name tick-property=ticked></div></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-disabled=\"!Guide.$valid || guidesDialog.disabled\" ng-click=guidesDialog.save() class=\"md-raised md-primary\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/horses/horse-dialog/horse-dialog.template.html","<md-dialog aria-label=\"Add horses\" class=horse-dialog><form name=AddHorses><md-toolbar><div class=md-toolbar-tools><h2>{{ horsesDialog.isNew ? \'Add a horse\' : \'Update the horse\' }}</h2><span flex=\"\"></span><md-button ng-click=horsesDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-input-container class=md-block><label>Name</label><input required type=text name=name ng-model=horsesDialog.data.name><div ng-messages=AddHorses.name.$error role=alert><div ng-message=required class=my-message>Name is required.</div></div></md-input-container><table><tr><td>Experience:</td><td layout=row><div ng-repeat=\"item in horsesDialog.experience\" layout-margin><md-checkbox ng-checked=\"horsesDialog.exists(item, horsesDialog.data.experience)\" ng-click=\"horsesDialog.toggle(item, horsesDialog.data.experience)\" class=md-primary>{{ item }}</md-checkbox></div></td></tr><tr><td>Age category:</td><td layout=row><div ng-repeat=\"item in horsesDialog.ageCategory\" layout-margin><md-checkbox ng-checked=\"horsesDialog.exists(item, horsesDialog.data.ageCategory)\" ng-click=\"horsesDialog.toggle(item, horsesDialog.data.ageCategory)\" class=md-primary>{{ item }}</md-checkbox></div></td></tr><tr><td>Weight:</td><td layout=row><div ng-repeat=\"item in horsesDialog.weight\" layout-margin><md-checkbox ng-checked=\"horsesDialog.exists(item, horsesDialog.data.weight)\" ng-click=\"horsesDialog.toggle(item, horsesDialog.data.weight)\" class=md-primary>{{ item }}</md-checkbox></div></td></tr></table></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-disabled=\"!AddHorses.$valid || horsesDialog.disabled\" ng-click=horsesDialog.save() class=\"md-raised md-primary\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/orders/info-dialog/info-dialog.template.html","<md-dialog aria-label=Info flex=services80 class=info-dialog><md-toolbar class=md-toolbar-tools><h2>Day report</h2><span flex></span><md-button ng-click=infoDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></md-toolbar><md-dialog-content class=md-dialog-content><div id=printJS-content><div class=day-report><h3>{{ infoDialog.date }}</h3><table class=tickets><thead><tr><th>Ride</th><th>Time</th><th>no\'s</th><th>Customer</th><th>Rider details</th><th>Guides/horses</th></tr></thead><tbody><tr ng-repeat-start=\"item in infoDialog.data\"><td class=bold><div ng-if=\"$index === 0 || infoDialog.data[$index-1].service.name !== item.service.name\">{{ item.service.name }}</div></td><td><div ng-if=\"$index === 0 || infoDialog.data[$index-1].service.name !== item.service.name || infoDialog.data[$index-1].slot !== item.slot\">{{ item.slot | timeFilter }}</div></td><td><div ng-if=\"$index === 0 || infoDialog.data[$index-1].customer.email !== item.customer.email || infoDialog.data[$index-1].customer.name !== item.customer.name || infoDialog.data[$index-1].service.name !== item.service.name || infoDialog.data[$index-1].slot !== item.slot\">{{ item.amount }}<span ng-if=item.amount>p</span></div></td><td><div ng-if=\"$index === 0 || infoDialog.data[$index-1].customer.email !== item.customer.email || infoDialog.data[$index-1].customer.name !== item.customer.name || infoDialog.data[$index-1].service.name !== item.service.name || infoDialog.data[$index-1].slot !== item.slot\"><div>{{ item.customer.name }}</div><span ng-if=item.customer.email class=small>{{ item.customer.email }}{{item.customer.phone ? \', \' : \'\'}}</span><span ng-if=item.customer.phone class=small>{{ item.customer.phone }}</span><div class=customer-comment>{{item.customer.comment}}</div></div></td><td><div>{{ item.rider.name }}</div><span class=small>{{ item.rider.ageCategory }}yo, </span><span class=small>{{ item.rider.weight }}st, </span><span class=small>{{ item.rider.experience }}</span></td><td><span class=guides>{{ infoDialog.formatListOfItems(item.guides) }}</span><br>🐴 &nbsp<span class=horses>{{ infoDialog.formatListOfItems(item.horses) }}</span></td></tr><tr ng-repeat-end ng-if=\"infoDialog.data[$index+1].service.name !== item.service.name || infoDialog.data[$index+1].slot !== item.slot || $last\" class=total-row><td>total</td><td></td><td>{{ item.total }}p</td><td></td><td></td><td></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between center\"><md-button ng-click=infoDialog.print() class=\"md-raised md-warn\"><md-icon class=material-icons>print</md-icon>Print</md-button><md-button ng-click=infoDialog.cancel() class=\"md-raised md-primary\">Ok</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/orders/order-dialog/order-dialog.template.html","<md-dialog aria-label=orders flex=50 class=order-dialog><form name=Order><md-toolbar><div class=md-toolbar-tools><h2>View order</h2><span flex=\"\"></span><md-button ng-click=ordersDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div layout=column><div flex><h3>Customer:</h3></div><div flex><table class=owner><tr><td style=width:150px>Name:</td><td>{{ ordersDialog.order.customer.name }}</td></tr><tr><td>Email:</td><td>{{ ordersDialog.order.customer.email }}</td></tr><tr><td>Phone:</td><td>{{ ordersDialog.order.customer.phone }}</td></tr><tr><td>Postal:</td><td>{{ ordersDialog.order.customer.postal }}</td></tr><tr><td>Price:</td><td>&pound;{{ ordersDialog.order.totalPrice }}</td></tr><tr><td>Status:</td><td>{{ ordersDialog.order.status | statusFilter}}</td></tr><tr><td>Payment type:</td><td>{{ ordersDialog.order.paymentType}}</td></tr></table></div></div><md-divider></md-divider><div layout=column><div flex><h3>Tickets:</h3></div><div flex ng-repeat=\"item in ordersDialog.order.tickets\"><h4>{{ item.serviceData.name }}</h4><div layout=row class=ticketData><p flex=20>Date:<label>{{ item.date }}</label></p><p flex=20>Time:<label>{{ item.start | timeFilter}} - {{ item.end | timeFilter}}</label></p><p flex=20>Status:<label>{{ item.status }}</label></p><p flex=40>Validation code:<label>{{ item.shortId }}</label></p></div><table class=riders><tr><th rowspan=\"{{ item.persons.length + 1 }}\">Riders:</th><th>Name</th><th>Experience</th><th>Weight</th><th>Age Category</th></tr><tr ng-repeat=\"person in item.persons\"><td>{{ person.name }}</td><td>{{ person.experience }}</td><td>{{ person.weight }}</td><td>{{ person.ageCategory }}</td></tr></table><md-divider></md-divider></div></div></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-between center\"><md-button ng-click=ordersDialog.cancelOrder() class=\"md-raised md-warn\">Cancel order</md-button><md-button ng-click=ordersDialog.cancel() class=\"md-raised md-primary\">Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/services/service-dialog/service-dialog.template.html","<md-dialog aria-label=service class=service-dialog><form name=Service><md-toolbar><div class=md-toolbar-tools><h2>{{ serviceDialog.isNew ? \'Add a service\' : \'Edit the service\' }}</h2><span flex=\"\"></span><md-button ng-click=serviceDialog.cancel() class=md-icon-button><md-icon aria-label=\"Close dialog\">clear</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-input-container class=md-block><label>Name</label><input type=text name=name required ng-model=serviceDialog.data.name></md-input-container><div layout=row layout-align=\"space-between center\"><div flex><md-input-container class=md-block><label>Duration (minutes)</label><input type=number min=1 name=duration ng-model=serviceDialog.data.duration></md-input-container></div><div flex><md-input-container class=md-block><label>Price (GBP)</label><input name=price ng-model=serviceDialog.data.price type=number step=0.01 min=0></md-input-container></div></div><md-input-container class=md-block><label>Description</label><input type=text name=description ng-model=serviceDialog.data.description></md-input-container><div layout=row layout-align=\"space-between center\"><div flex><md-input-container class=md-block><label>Minimum amount of riders</label><input type=number min=1 name=ridersAmount ng-model=serviceDialog.data.ridersAmount></md-input-container></div><div flex><md-input-container class=md-block><md-checkbox name=extraHorse ng-model=serviceDialog.data.extraHorse class=md-primary>Extra horse for guide</md-checkbox></md-input-container></div></div><table><tr><td>Experience:</td><td layout=row><div ng-repeat=\"item in serviceDialog.experience\" layout-margin><md-checkbox ng-checked=\"serviceDialog.exists(item, serviceDialog.data.experience)\" ng-click=\"serviceDialog.toggle(item, serviceDialog.data.experience)\" class=md-primary>{{ item }}</md-checkbox></div></td></tr><tr><td>Age category:</td><td layout=row><div ng-repeat=\"item in serviceDialog.ageCategory\" layout-margin><md-checkbox ng-checked=\"serviceDialog.exists(item, serviceDialog.data.ageCategory)\" ng-click=\"serviceDialog.toggle(item, serviceDialog.data.ageCategory)\" class=md-primary>{{ item }}</md-checkbox></div></td></tr><tr><td>Weight:</td><td layout=row><div ng-repeat=\"item in serviceDialog.weight\" layout-margin><md-checkbox ng-checked=\"serviceDialog.exists(item, serviceDialog.data.weight)\" ng-click=\"serviceDialog.toggle(item, serviceDialog.data.weight)\" class=md-primary>{{ item }}</md-checkbox></div></td></tr></table><md-divider></md-divider><div class=timeslots><label>Available timeslots</label><div class=timeslots-list><div ng-repeat=\"item in serviceDialog.time\" ng-class=\"serviceDialog.exists(item, serviceDialog.selectedTime) ? \'checked\' : \'\'\" ng-click=\"serviceDialog.toggle(item, serviceDialog.selectedTime)\" class=timeslots-item>{{item | timeFilter}}<md-tooltip>Start at {{item | timeFilter}}. End at {{(serviceDialog.data.duration + item) | timeFilter}}.</md-tooltip></div></div><p ng-if=serviceDialog.isNew>*Click on timeslot to allow or disallow</p><p ng-if=!serviceDialog.isNew>*Changing timeslots is available only for new services</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-disabled=\"!Service.$valid || serviceDialog.disabled\" ng-click=serviceDialog.save() class=\"md-raised md-primary\">Save</md-button></md-dialog-actions></form></md-dialog>");}]);